export const RESTRICTED_BOUNDS = {
  DESKTOP: {
    east: 0.448544,
    north: 51.775317,
    south: 51.201574,
    west: -0.753690,
  },
  MOBILE: {
    east: 0.448544,
    north: 52.775317,
    south: 49.201574,
    west: -0.753690,
  },
  TABLET: {
    east: 0.448544,
    north: 51.775317,
    south: 51.201574,
    west: -0.753690,
  },
};

// data from https://tfl.gov.uk/modes/driving/ultra-low-emission-zone/ulez-expansion-2023
export const ULEZ_INNER_BOUNDS = [
  { lat: 51.5240183, lng: 0.0726507 },
  { lat: 51.5244455, lng: 0.0724576 },
  { lat: 51.5247258, lng: 0.0722001 },
  { lat: 51.5254735, lng: 0.0722001 },
  { lat: 51.5265548, lng: 0.0722645 },
  { lat: 51.5284104, lng: 0.0722216 },
  { lat: 51.5307732, lng: 0.0721357 },
  { lat: 51.5325352, lng: 0.0715778 },
  { lat: 51.5337766, lng: 0.0707624 },
  { lat: 51.5360323, lng: 0.0691317 },
  { lat: 51.5362458, lng: 0.068681 },
  { lat: 51.5364594, lng: 0.0682948 },
  { lat: 51.5368464, lng: 0.0683163 },
  { lat: 51.5377674, lng: 0.0677369 },
  { lat: 51.5387016, lng: 0.0670073 },
  { lat: 51.5393556, lng: 0.0667069 },
  { lat: 51.5399962, lng: 0.0664065 },
  { lat: 51.5410238, lng: 0.0662992 },
  { lat: 51.5415443, lng: 0.0663636 },
  { lat: 51.542265, lng: 0.0665782 },
  { lat: 51.543426, lng: 0.067415 },
  { lat: 51.5444402, lng: 0.0679729 },
  { lat: 51.5456279, lng: 0.0682304 },
  { lat: 51.5461616, lng: 0.0682733 },
  { lat: 51.5476161, lng: 0.0681446 },
  { lat: 51.5526331, lng: 0.0673721 },
  { lat: 51.5534203, lng: 0.0670288 },
  { lat: 51.5547278, lng: 0.0665996 },
  { lat: 51.5551414, lng: 0.0664924 },
  { lat: 51.5561954, lng: 0.0652049 },
  { lat: 51.5574628, lng: 0.0633381 },
  { lat: 51.5582365, lng: 0.0622867 },
  { lat: 51.5589702, lng: 0.0609348 },
  { lat: 51.5599307, lng: 0.0594113 },
  { lat: 51.5620118, lng: 0.0571583 },
  { lat: 51.5647996, lng: 0.0545834 },
  { lat: 51.5666403, lng: 0.0530169 },
  { lat: 51.5699081, lng: 0.0504206 },
  { lat: 51.5714818, lng: 0.0488756 },
  { lat: 51.5720286, lng: 0.0482533 },
  { lat: 51.5723354, lng: 0.0476525 },
  { lat: 51.573349, lng: 0.0463221 },
  { lat: 51.5741891, lng: 0.045378 },
  { lat: 51.5750026, lng: 0.0446484 },
  { lat: 51.5752427, lng: 0.0440905 },
  { lat: 51.575576, lng: 0.0431035 },
  { lat: 51.5757761, lng: 0.0427602 },
  { lat: 51.5761895, lng: 0.0427602 },
  { lat: 51.5767096, lng: 0.043082 },
  { lat: 51.5776697, lng: 0.0425027 },
  { lat: 51.5795632, lng: 0.0413225 },
  { lat: 51.58127, lng: 0.0402711 },
  { lat: 51.5824833, lng: 0.0397132 },
  { lat: 51.58371, lng: 0.0397346 },
  { lat: 51.5861499, lng: 0.0399278 },
  { lat: 51.5875631, lng: 0.0396917 },
  { lat: 51.5891896, lng: 0.0389192 },
  { lat: 51.5907494, lng: 0.0378678 },
  { lat: 51.5919625, lng: 0.0369237 },
  { lat: 51.5932422, lng: 0.0357006 },
  { lat: 51.5938821, lng: 0.0349925 },
  { lat: 51.5945352, lng: 0.033233 },
  { lat: 51.5954683, lng: 0.0302074 },
  { lat: 51.5960015, lng: 0.0273536 },
  { lat: 51.5962548, lng: 0.0259588 },
  { lat: 51.5962148, lng: 0.0240276 },
  { lat: 51.5956283, lng: 0.0208948 },
  { lat: 51.5952017, lng: 0.0178693 },
  { lat: 51.5951218, lng: 0.0165389 },
  { lat: 51.5950151, lng: 0.0158093 },
  { lat: 51.5950551, lng: 0.0129126 },
  { lat: 51.5952551, lng: 0.0117324 },
  { lat: 51.5957749, lng: 0.0095222 },
  { lat: 51.596748, lng: 0.007119 },
  { lat: 51.597601, lng: 0.005338 },
  { lat: 51.5984408, lng: 0.0032566 },
  { lat: 51.5992538, lng: 0.0011967 },
  { lat: 51.5996937, lng: -0.0006058 },
  { lat: 51.6000669, lng: -0.0023224 },
  { lat: 51.6003601, lng: -0.0050261 },
  { lat: 51.6003334, lng: -0.0082233 },
  { lat: 51.6002135, lng: -0.0119783 },
  { lat: 51.6002268, lng: -0.0135662 },
  { lat: 51.6005067, lng: -0.015712 },
  { lat: 51.6008932, lng: -0.0169565 },
  { lat: 51.601493, lng: -0.0182225 },
  { lat: 51.6027991, lng: -0.0205614 },
  { lat: 51.603852, lng: -0.0224282 },
  { lat: 51.605078, lng: -0.0246384 },
  { lat: 51.6060109, lng: -0.0264623 },
  { lat: 51.6068771, lng: -0.0282862 },
  { lat: 51.6071437, lng: -0.0287582 },
  { lat: 51.6073702, lng: -0.0294449 },
  { lat: 51.6080498, lng: -0.0302817 },
  { lat: 51.6085562, lng: -0.0305607 },
  { lat: 51.6091825, lng: -0.0306894 },
  { lat: 51.6102486, lng: -0.030904 },
  { lat: 51.6112346, lng: -0.0315477 },
  { lat: 51.6120741, lng: -0.0327923 },
  { lat: 51.6124739, lng: -0.0340154 },
  { lat: 51.6127537, lng: -0.0353243 },
  { lat: 51.6129402, lng: -0.036719 },
  { lat: 51.6129536, lng: -0.0382211 },
  { lat: 51.6127404, lng: -0.0398733 },
  { lat: 51.6120208, lng: -0.042341 },
  { lat: 51.6114878, lng: -0.0439503 },
  { lat: 51.6112613, lng: -0.0448944 },
  { lat: 51.6111947, lng: -0.0462892 },
  { lat: 51.611248, lng: -0.0474264 },
  { lat: 51.6116744, lng: -0.0492289 },
  { lat: 51.6124739, lng: -0.0509884 },
  { lat: 51.6129802, lng: -0.0523188 },
  { lat: 51.6131534, lng: -0.0537135 },
  { lat: 51.6134599, lng: -0.056267 },
  { lat: 51.6139262, lng: -0.0593569 },
  { lat: 51.6141394, lng: -0.0614168 },
  { lat: 51.6145258, lng: -0.0639274 },
  { lat: 51.6147523, lng: -0.0673391 },
  { lat: 51.6146591, lng: -0.0705363 },
  { lat: 51.6144992, lng: -0.072725 },
  { lat: 51.614206, lng: -0.0745918 },
  { lat: 51.6140861, lng: -0.0754287 },
  { lat: 51.6141261, lng: -0.076802 },
  { lat: 51.6143126, lng: -0.078304 },
  { lat: 51.6146324, lng: -0.0793984 },
  { lat: 51.6152586, lng: -0.0812652 },
  { lat: 51.6157117, lng: -0.0833466 },
  { lat: 51.6161513, lng: -0.085385 },
  { lat: 51.6160181, lng: -0.0863721 },
  { lat: 51.6161114, lng: -0.0872519 },
  { lat: 51.6163912, lng: -0.0881745 },
  { lat: 51.6161647, lng: -0.0877668 },
  { lat: 51.616138, lng: -0.0896337 },
  { lat: 51.6160847, lng: -0.0920798 },
  { lat: 51.6159248, lng: -0.0946333 },
  { lat: 51.6158449, lng: -0.096307 },
  { lat: 51.6157516, lng: -0.0971224 },
  { lat: 51.6154185, lng: -0.0983026 },
  { lat: 51.6146724, lng: -0.1006844 },
  { lat: 51.6128869, lng: -0.1059415 },
  { lat: 51.6123273, lng: -0.1078727 },
  { lat: 51.612234, lng: -0.1090743 },
  { lat: 51.6123006, lng: -0.1104905 },
  { lat: 51.6125005, lng: -0.1127007 },
  { lat: 51.6125138, lng: -0.1139881 },
  { lat: 51.6123806, lng: -0.116091 },
  { lat: 51.612274, lng: -0.1177218 },
  { lat: 51.6124872, lng: -0.1197173 },
  { lat: 51.6128869, lng: -0.12167 },
  { lat: 51.6136331, lng: -0.1244166 },
  { lat: 51.614246, lng: -0.1263048 },
  { lat: 51.6146324, lng: -0.1273563 },
  { lat: 51.614699, lng: -0.1279356 },
  { lat: 51.6145658, lng: -0.1287081 },
  { lat: 51.6135398, lng: -0.1313259 },
  { lat: 51.6123806, lng: -0.1334931 },
  { lat: 51.6112746, lng: -0.1351454 },
  { lat: 51.6108882, lng: -0.1357033 },
  { lat: 51.6104485, lng: -0.1375272 },
  { lat: 51.6093158, lng: -0.1419046 },
  { lat: 51.608303, lng: -0.1450588 },
  { lat: 51.6071303, lng: -0.1488998 },
  { lat: 51.6064507, lng: -0.1514318 },
  { lat: 51.6058643, lng: -0.1540281 },
  { lat: 51.6056378, lng: -0.155616 },
  { lat: 51.6055178, lng: -0.1570751 },
  { lat: 51.6056378, lng: -0.1589634 },
  { lat: 51.6056777, lng: -0.160444 },
  { lat: 51.6055312, lng: -0.1619031 },
  { lat: 51.6050647, lng: -0.1634695 },
  { lat: 51.6041451, lng: -0.1656797 },
  { lat: 51.6032389, lng: -0.1687481 },
  { lat: 51.6020527, lng: -0.1717093 },
  { lat: 51.6009199, lng: -0.1738765 },
  { lat: 51.6000535, lng: -0.1754214 },
  { lat: 51.5985474, lng: -0.1773526 },
  { lat: 51.5973744, lng: -0.1788547 },
  { lat: 51.5969346, lng: -0.1795628 },
  { lat: 51.595495, lng: -0.182245 },
  { lat: 51.5937754, lng: -0.1853349 },
  { lat: 51.590856, lng: -0.1907422 },
  { lat: 51.5903761, lng: -0.1918151 },
  { lat: 51.5898695, lng: -0.1932528 },
  { lat: 51.5894829, lng: -0.1955702 },
  { lat: 51.5894696, lng: -0.1967074 },
  { lat: 51.5895229, lng: -0.1976087 },
  { lat: 51.5895895, lng: -0.1993038 },
  { lat: 51.5895762, lng: -0.2007629 },
  { lat: 51.5892296, lng: -0.2029087 },
  { lat: 51.5885497, lng: -0.2056982 },
  { lat: 51.5880297, lng: -0.2073719 },
  { lat: 51.5875631, lng: -0.2082731 },
  { lat: 51.5866165, lng: -0.2092173 },
  { lat: 51.5836967, lng: -0.2107837 },
  { lat: 51.5823367, lng: -0.2110626 },
  { lat: 51.5814833, lng: -0.2113845 },
  { lat: 51.5803766, lng: -0.2124145 },
  { lat: 51.5787898, lng: -0.2140667 },
  { lat: 51.5780164, lng: -0.2151396 },
  { lat: 51.577483, lng: -0.2163198 },
  { lat: 51.5769362, lng: -0.2176501 },
  { lat: 51.5762962, lng: -0.2189376 },
  { lat: 51.5751226, lng: -0.2202251 },
  { lat: 51.5742691, lng: -0.2210404 },
  { lat: 51.5736557, lng: -0.2221992 },
  { lat: 51.5734023, lng: -0.2225639 },
  { lat: 51.5729222, lng: -0.2244951 },
  { lat: 51.5725754, lng: -0.2269413 },
  { lat: 51.5721754, lng: -0.2285506 },
  { lat: 51.5713351, lng: -0.2309968 },
  { lat: 51.5704816, lng: -0.2330567 },
  { lat: 51.5702815, lng: -0.2337648 },
  { lat: 51.5696147, lng: -0.2378418 },
  { lat: 51.5693746, lng: -0.2390434 },
  { lat: 51.5683343, lng: -0.2416184 },
  { lat: 51.5673606, lng: -0.2439787 },
  { lat: 51.5667337, lng: -0.2458884 },
  { lat: 51.5661068, lng: -0.2477767 },
  { lat: 51.5655333, lng: -0.2492144 },
  { lat: 51.5649197, lng: -0.2502229 },
  { lat: 51.5642794, lng: -0.2508452 },
  { lat: 51.5630122, lng: -0.2517249 },
  { lat: 51.5607845, lng: -0.2527978 },
  { lat: 51.5595706, lng: -0.2533557 },
  { lat: 51.5589035, lng: -0.2535488 },
  { lat: 51.5577429, lng: -0.2533986 },
  { lat: 51.5567023, lng: -0.2530338 },
  { lat: 51.5560486, lng: -0.2526047 },
  { lat: 51.555555, lng: -0.252433 },
  { lat: 51.5549012, lng: -0.2526691 },
  { lat: 51.553487, lng: -0.2537634 },
  { lat: 51.5529, lng: -0.2545359 },
  { lat: 51.5524597, lng: -0.2560594 },
  { lat: 51.5521661, lng: -0.258291 },
  { lat: 51.5518459, lng: -0.2600934 },
  { lat: 51.5515524, lng: -0.2609732 },
  { lat: 51.5504449, lng: -0.2619817 },
  { lat: 51.5495376, lng: -0.2625825 },
  { lat: 51.5482299, lng: -0.2637841 },
  { lat: 51.5469623, lng: -0.2665951 },
  { lat: 51.5460415, lng: -0.2688267 },
  { lat: 51.5446404, lng: -0.2718737 },
  { lat: 51.5439064, lng: -0.2732255 },
  { lat: 51.5431458, lng: -0.2742126 },
  { lat: 51.5429456, lng: -0.2746632 },
  { lat: 51.5403165, lng: -0.2766587 },
  { lat: 51.5391554, lng: -0.2777316 },
  { lat: 51.5388351, lng: -0.2786972 },
  { lat: 51.5381544, lng: -0.2809503 },
  { lat: 51.5380477, lng: -0.2814223 },
  { lat: 51.5366462, lng: -0.2846839 },
  { lat: 51.5353516, lng: -0.2873876 },
  { lat: 51.5340302, lng: -0.289426 },
  { lat: 51.5325752, lng: -0.2913572 },
  { lat: 51.5316142, lng: -0.2926232 },
  { lat: 51.5306397, lng: -0.292473 },
  { lat: 51.5300924, lng: -0.2923872 },
  { lat: 51.5285439, lng: -0.2923014 },
  { lat: 51.5268352, lng: -0.2921297 },
  { lat: 51.5258072, lng: -0.2920224 },
  { lat: 51.5249928, lng: -0.2922585 },
  { lat: 51.5247125, lng: -0.2922155 },
  { lat: 51.5239515, lng: -0.291722 },
  { lat: 51.5230436, lng: -0.2914645 },
  { lat: 51.5203333, lng: -0.2913572 },
  { lat: 51.5191316, lng: -0.2913143 },
  { lat: 51.5176495, lng: -0.2911641 },
  { lat: 51.5164478, lng: -0.2912929 },
  { lat: 51.514979, lng: -0.292001 },
  { lat: 51.5108125, lng: -0.2918508 },
  { lat: 51.5079279, lng: -0.2913572 },
  { lat: 51.5035471, lng: -0.2888896 },
  { lat: 51.502385, lng: -0.2871945 },
  { lat: 51.5015302, lng: -0.2857139 },
  { lat: 51.5006085, lng: -0.2842333 },
  { lat: 51.4994731, lng: -0.283139 },
  { lat: 51.4988319, lng: -0.282624 },
  { lat: 51.4978568, lng: -0.2820661 },
  { lat: 51.4972824, lng: -0.2818515 },
  { lat: 51.4958396, lng: -0.2820446 },
  { lat: 51.4947709, lng: -0.2822806 },
  { lat: 51.4930742, lng: -0.2821519 },
  { lat: 51.492139, lng: -0.2819373 },
  { lat: 51.4918184, lng: -0.281315 },
  { lat: 51.4915913, lng: -0.2809074 },
  { lat: 51.4911638, lng: -0.2808859 },
  { lat: 51.4903087, lng: -0.2791264 },
  { lat: 51.4896139, lng: -0.2774312 },
  { lat: 51.4890929, lng: -0.2759292 },
  { lat: 51.4888256, lng: -0.274749 },
  { lat: 51.4885451, lng: -0.2735259 },
  { lat: 51.4883714, lng: -0.2721741 },
  { lat: 51.4882912, lng: -0.270672 },
  { lat: 51.4881175, lng: -0.2695777 },
  { lat: 51.4878102, lng: -0.2681615 },
  { lat: 51.4877567, lng: -0.2652218 },
  { lat: 51.4877701, lng: -0.2632691 },
  { lat: 51.4877567, lng: -0.2607586 },
  { lat: 51.4877567, lng: -0.2589347 },
  { lat: 51.4877033, lng: -0.2578618 },
  { lat: 51.4874628, lng: -0.2557804 },
  { lat: 51.4871421, lng: -0.2537419 },
  { lat: 51.4871956, lng: -0.2529265 },
  { lat: 51.4873559, lng: -0.2525189 },
  { lat: 51.4873826, lng: -0.2522399 },
  { lat: 51.487249, lng: -0.2520253 },
  { lat: 51.4868214, lng: -0.2518322 },
  { lat: 51.4866477, lng: -0.2520253 },
  { lat: 51.4865008, lng: -0.2523901 },
  { lat: 51.4867012, lng: -0.2528622 },
  { lat: 51.4868615, lng: -0.253227 },
  { lat: 51.4869551, lng: -0.2541282 },
  { lat: 51.4871421, lng: -0.2553727 },
  { lat: 51.4873693, lng: -0.2568104 },
  { lat: 51.4874895, lng: -0.2583768 },
  { lat: 51.4875029, lng: -0.2599218 },
  { lat: 51.4874895, lng: -0.2659728 },
  { lat: 51.4874762, lng: -0.267389 },
  { lat: 51.4876899, lng: -0.2688052 },
  { lat: 51.4879972, lng: -0.2703502 },
  { lat: 51.4880908, lng: -0.2715304 },
  { lat: 51.488211, lng: -0.272968 },
  { lat: 51.488505, lng: -0.2746417 },
  { lat: 51.4889726, lng: -0.2764442 },
  { lat: 51.4897075, lng: -0.2786328 },
  { lat: 51.4909099, lng: -0.2814223 },
  { lat: 51.4910034, lng: -0.2819373 },
  { lat: 51.4909767, lng: -0.2823879 },
  { lat: 51.4911237, lng: -0.2829673 },
  { lat: 51.4906293, lng: -0.2841689 },
  { lat: 51.4898277, lng: -0.2857139 },
  { lat: 51.4892532, lng: -0.2870013 },
  { lat: 51.4889192, lng: -0.2873447 },
  { lat: 51.4885718, lng: -0.2873447 },
  { lat: 51.4847504, lng: -0.2872374 },
  { lat: 51.4838551, lng: -0.2871086 },
  { lat: 51.483374, lng: -0.2868297 },
  { lat: 51.4827593, lng: -0.2866151 },
  { lat: 51.4823585, lng: -0.2862503 },
  { lat: 51.4817037, lng: -0.2852847 },
  { lat: 51.4811959, lng: -0.2840616 },
  { lat: 51.4809687, lng: -0.2834823 },
  { lat: 51.4801134, lng: -0.2825811 },
  { lat: 51.4789241, lng: -0.2814653 },
  { lat: 51.4785365, lng: -0.2812936 },
  { lat: 51.4773337, lng: -0.2816584 },
  { lat: 51.4767457, lng: -0.2817442 },
  { lat: 51.4756231, lng: -0.2811434 },
  { lat: 51.4751286, lng: -0.2802851 },
  { lat: 51.4743935, lng: -0.2784183 },
  { lat: 51.4737119, lng: -0.2769162 },
  { lat: 51.4733777, lng: -0.276294 },
  { lat: 51.4730699, lng: -0.2762078 },
  { lat: 51.472161, lng: -0.2765297 },
  { lat: 51.4708511, lng: -0.276637 },
  { lat: 51.4692605, lng: -0.276637 },
  { lat: 51.4679372, lng: -0.2770017 },
  { lat: 51.4675496, lng: -0.2770017 },
  { lat: 51.466801, lng: -0.2767443 },
  { lat: 51.466039, lng: -0.2764653 },
  { lat: 51.4651568, lng: -0.276358 },
  { lat: 51.4644082, lng: -0.276358 },
  { lat: 51.464368, lng: -0.2753924 },
  { lat: 51.4642344, lng: -0.2719592 },
  { lat: 51.4642344, lng: -0.2699422 },
  { lat: 51.464368, lng: -0.2685474 },
  { lat: 51.4648092, lng: -0.2670883 },
  { lat: 51.4649429, lng: -0.2648782 },
  { lat: 51.4652236, lng: -0.2613591 },
  { lat: 51.4651434, lng: -0.2585052 },
  { lat: 51.4652904, lng: -0.2546643 },
  { lat: 51.4652771, lng: -0.2510165 },
  { lat: 51.4651033, lng: -0.2489995 },
  { lat: 51.4653038, lng: -0.243914 },
  { lat: 51.4651969, lng: -0.2418755 },
  { lat: 51.4644884, lng: -0.2353739 },
  { lat: 51.4642344, lng: -0.2338504 },
  { lat: 51.4638601, lng: -0.23252 },
  { lat: 51.4634189, lng: -0.2294301 },
  { lat: 51.4629109, lng: -0.2257179 },
  { lat: 51.4627294, lng: -0.2236712 },
  { lat: 51.4624754, lng: -0.222255 },
  { lat: 51.461974, lng: -0.221225 },
  { lat: 51.4616064, lng: -0.220195 },
  { lat: 51.4611786, lng: -0.2182316 },
  { lat: 51.4610315, lng: -0.217427 },
  { lat: 51.4607374, lng: -0.2167403 },
  { lat: 51.4606037, lng: -0.2158284 },
  { lat: 51.4604566, lng: -0.2151096 },
  { lat: 51.4603564, lng: -0.2145624 },
  { lat: 51.4600942, lng: -0.2133081 },
  { lat: 51.4598268, lng: -0.211849 },
  { lat: 51.4593588, lng: -0.2105186 },
  { lat: 51.4589444, lng: -0.2090809 },
  { lat: 51.4580352, lng: -0.2071498 },
  { lat: 51.457594, lng: -0.2062056 },
  { lat: 51.4570726, lng: -0.2055833 },
  { lat: 51.4568988, lng: -0.2050898 },
  { lat: 51.4567116, lng: -0.2026007 },
  { lat: 51.4567586, lng: -0.2017207 },
  { lat: 51.4569324, lng: -0.199811 },
  { lat: 51.4569926, lng: -0.1990385 },
  { lat: 51.4570394, lng: -0.1984591 },
  { lat: 51.4571931, lng: -0.1977618 },
  { lat: 51.4574605, lng: -0.197912 },
  { lat: 51.4577681, lng: -0.1979656 },
  { lat: 51.4579552, lng: -0.1978154 },
  { lat: 51.4581758, lng: -0.1970107 },
  { lat: 51.4584566, lng: -0.1960344 },
  { lat: 51.4587173, lng: -0.1947255 },
  { lat: 51.4589312, lng: -0.1936312 },
  { lat: 51.4590048, lng: -0.1929767 },
  { lat: 51.458958, lng: -0.1922793 },
  { lat: 51.4589112, lng: -0.1917751 },
  { lat: 51.4590449, lng: -0.1913781 },
  { lat: 51.4593669, lng: -0.19092 },
  { lat: 51.4599017, lng: -0.1909414 },
  { lat: 51.460637, lng: -0.19092 },
  { lat: 51.4612787, lng: -0.1905766 },
  { lat: 51.4616798, lng: -0.1897398 },
  { lat: 51.4618001, lng: -0.1886025 },
  { lat: 51.4618669, lng: -0.1879159 },
  { lat: 51.4620273, lng: -0.1867357 },
  { lat: 51.4621878, lng: -0.1863495 },
  { lat: 51.4627894, lng: -0.1861563 },
  { lat: 51.4629231, lng: -0.1854912 },
  { lat: 51.4628696, lng: -0.1848903 },
  { lat: 51.4625755, lng: -0.1844826 },
  { lat: 51.4619204, lng: -0.1846329 },
  { lat: 51.4610648, lng: -0.1839462 },
  { lat: 51.4606637, lng: -0.1835385 },
  { lat: 51.4599551, lng: -0.1827017 },
  { lat: 51.4592867, lng: -0.1822511 },
  { lat: 51.4591797, lng: -0.1819506 },
  { lat: 51.4594872, lng: -0.1807919 },
  { lat: 51.4596343, lng: -0.1800838 },
  { lat: 51.4594471, lng: -0.1796332 },
  { lat: 51.4589123, lng: -0.1794401 },
  { lat: 51.4584978, lng: -0.1792899 },
  { lat: 51.4583775, lng: -0.1791397 },
  { lat: 51.4584845, lng: -0.1770583 },
  { lat: 51.4585914, lng: -0.1752773 },
  { lat: 51.4586583, lng: -0.1749554 },
  { lat: 51.4593535, lng: -0.1729599 },
  { lat: 51.4600487, lng: -0.1709643 },
  { lat: 51.4604899, lng: -0.1696125 },
  { lat: 51.4607172, lng: -0.1684752 },
  { lat: 51.4609177, lng: -0.1672736 },
  { lat: 51.4608776, lng: -0.1666299 },
  { lat: 51.4610648, lng: -0.1634541 },
  { lat: 51.4611717, lng: -0.1617375 },
  { lat: 51.4604364, lng: -0.1615873 },
  { lat: 51.4601022, lng: -0.1614157 },
  { lat: 51.4598214, lng: -0.1606646 },
  { lat: 51.4598482, lng: -0.1596561 },
  { lat: 51.4599685, lng: -0.1570597 },
  { lat: 51.4600888, lng: -0.156695 },
  { lat: 51.4611584, lng: -0.1564804 },
  { lat: 51.4613455, lng: -0.1564804 },
  { lat: 51.4613589, lng: -0.1560941 },
  { lat: 51.4609846, lng: -0.1562444 },
  { lat: 51.4601423, lng: -0.1563516 },
  { lat: 51.4596744, lng: -0.156416 },
  { lat: 51.4587385, lng: -0.1556865 },
  { lat: 51.4575218, lng: -0.1545707 },
  { lat: 51.4571475, lng: -0.154163 },
  { lat: 51.4567464, lng: -0.1533476 },
  { lat: 51.4540989, lng: -0.1474467 },
  { lat: 51.4541391, lng: -0.1465884 },
  { lat: 51.4542193, lng: -0.1460734 },
  { lat: 51.4533769, lng: -0.1438847 },
  { lat: 51.4527484, lng: -0.1425114 },
  { lat: 51.4523607, lng: -0.1420823 },
  { lat: 51.4518258, lng: -0.1420179 },
  { lat: 51.451331, lng: -0.1419965 },
  { lat: 51.4509566, lng: -0.1417604 },
  { lat: 51.4504485, lng: -0.139958 },
  { lat: 51.4498735, lng: -0.1377049 },
  { lat: 51.449138, lng: -0.1353231 },
  { lat: 51.4482821, lng: -0.1329413 },
  { lat: 51.4478542, lng: -0.1318041 },
  { lat: 51.4476402, lng: -0.1304951 },
  { lat: 51.4470384, lng: -0.1284781 },
  { lat: 51.4462761, lng: -0.1266542 },
  { lat: 51.4452865, lng: -0.1243583 },
  { lat: 51.4450591, lng: -0.1238004 },
  { lat: 51.4447783, lng: -0.1225129 },
  { lat: 51.4445108, lng: -0.1219335 },
  { lat: 51.4441497, lng: -0.12041 },
  { lat: 51.4433606, lng: -0.1171914 },
  { lat: 51.4429861, lng: -0.116097 },
  { lat: 51.4424244, lng: -0.11511 },
  { lat: 51.4415952, lng: -0.1139084 },
  { lat: 51.4411404, lng: -0.1127282 },
  { lat: 51.4407927, lng: -0.1108614 },
  { lat: 51.4405386, lng: -0.109295 },
  { lat: 51.4406054, lng: -0.1088229 },
  { lat: 51.4411003, lng: -0.1085869 },
  { lat: 51.4414481, lng: -0.1082435 },
  { lat: 51.4415016, lng: -0.1080075 },
  { lat: 51.4412073, lng: -0.1069132 },
  { lat: 51.4410468, lng: -0.1059905 },
  { lat: 51.4409532, lng: -0.1049605 },
  { lat: 51.4407392, lng: -0.1039735 },
  { lat: 51.4404717, lng: -0.1030722 },
  { lat: 51.4399768, lng: -0.1019994 },
  { lat: 51.4396959, lng: -0.1014844 },
  { lat: 51.4394953, lng: -0.1006046 },
  { lat: 51.4393883, lng: -0.0995532 },
  { lat: 51.4394685, lng: -0.0984803 },
  { lat: 51.439736, lng: -0.0974718 },
  { lat: 51.4402309, lng: -0.0966349 },
  { lat: 51.4405787, lng: -0.0956908 },
  { lat: 51.4410201, lng: -0.0940386 },
  { lat: 51.4411538, lng: -0.0928369 },
  { lat: 51.4412073, lng: -0.0915709 },
  { lat: 51.4411939, lng: -0.0900474 },
  { lat: 51.4411137, lng: -0.0890818 },
  { lat: 51.4409532, lng: -0.0883308 },
  { lat: 51.4419563, lng: -0.0842968 },
  { lat: 51.4420901, lng: -0.0824514 },
  { lat: 51.442411, lng: -0.0790826 },
  { lat: 51.4425314, lng: -0.0784817 },
  { lat: 51.4427454, lng: -0.0767222 },
  { lat: 51.4431734, lng: -0.0748554 },
  { lat: 51.443588, lng: -0.0736538 },
  { lat: 51.443695, lng: -0.0729886 },
  { lat: 51.4432135, lng: -0.0691691 },
  { lat: 51.4432135, lng: -0.068225 },
  { lat: 51.4433606, lng: -0.0675383 },
  { lat: 51.4430263, lng: -0.0668731 },
  { lat: 51.4426652, lng: -0.0664225 },
  { lat: 51.4421302, lng: -0.0657788 },
  { lat: 51.4413678, lng: -0.0649634 },
  { lat: 51.4411137, lng: -0.0643841 },
  { lat: 51.4408061, lng: -0.0630966 },
  { lat: 51.4406456, lng: -0.0617877 },
  { lat: 51.4405787, lng: -0.0603286 },
  { lat: 51.4406188, lng: -0.0591698 },
  { lat: 51.4406054, lng: -0.0581399 },
  { lat: 51.4403112, lng: -0.0572601 },
  { lat: 51.4396424, lng: -0.0554577 },
  { lat: 51.4392144, lng: -0.05402 },
  { lat: 51.4393482, lng: -0.0538913 },
  { lat: 51.4398431, lng: -0.0538698 },
  { lat: 51.4402176, lng: -0.0537411 },
  { lat: 51.4403781, lng: -0.0529042 },
  { lat: 51.4401908, lng: -0.0517455 },
  { lat: 51.4400036, lng: -0.0511876 },
  { lat: 51.4413143, lng: -0.0475827 },
  { lat: 51.4415551, lng: -0.047454 },
  { lat: 51.4421837, lng: -0.047454 },
  { lat: 51.4423977, lng: -0.0472608 },
  { lat: 51.4423174, lng: -0.0423685 },
  { lat: 51.4421034, lng: -0.0398579 },
  { lat: 51.4424645, lng: -0.0357166 },
  { lat: 51.4423575, lng: -0.0342146 },
  { lat: 51.4420098, lng: -0.032734 },
  { lat: 51.4420098, lng: -0.0321332 },
  { lat: 51.4423442, lng: -0.0308028 },
  { lat: 51.4429728, lng: -0.0293437 },
  { lat: 51.4431868, lng: -0.0286785 },
  { lat: 51.4432938, lng: -0.0272194 },
  { lat: 51.443481, lng: -0.0268117 },
  { lat: 51.4438956, lng: -0.0262967 },
  { lat: 51.44423, lng: -0.0255886 },
  { lat: 51.4445777, lng: -0.024108 },
  { lat: 51.4447114, lng: -0.0230566 },
  { lat: 51.444912, lng: -0.0224343 },
  { lat: 51.444912, lng: -0.0210181 },
  { lat: 51.4452464, lng: -0.0200525 },
  { lat: 51.4458749, lng: -0.0197306 },
  { lat: 51.4461023, lng: -0.0195804 },
  { lat: 51.4462093, lng: -0.0192371 },
  { lat: 51.4460755, lng: -0.0182286 },
  { lat: 51.4457144, lng: -0.0152245 },
  { lat: 51.4454069, lng: -0.0130144 },
  { lat: 51.4452062, lng: -0.0110832 },
  { lat: 51.4451528, lng: -0.0059977 },
  { lat: 51.4452464, lng: 0.0015768 },
  { lat: 51.44534, lng: 0.0043234 },
  { lat: 51.445447, lng: 0.0052461 },
  { lat: 51.4456342, lng: 0.0057182 },
  { lat: 51.4457144, lng: 0.0085077 },
  { lat: 51.4458883, lng: 0.0113615 },
  { lat: 51.4459953, lng: 0.013164 },
  { lat: 51.4462093, lng: 0.0139579 },
  { lat: 51.4465837, lng: 0.0153956 },
  { lat: 51.4469314, lng: 0.016447 },
  { lat: 51.4480414, lng: 0.0215754 },
  { lat: 51.4487769, lng: 0.0244078 },
  { lat: 51.4499938, lng: 0.0284847 },
  { lat: 51.4503014, lng: 0.0292572 },
  { lat: 51.4504886, lng: 0.029901 },
  { lat: 51.4511572, lng: 0.0319609 },
  { lat: 51.452013, lng: 0.0340637 },
  { lat: 51.4526548, lng: 0.0353512 },
  { lat: 51.4528554, lng: 0.0352868 },
  { lat: 51.4530693, lng: 0.035437 },
  { lat: 51.45331, lng: 0.0364241 },
  { lat: 51.4542861, lng: 0.0378403 },
  { lat: 51.4558773, lng: 0.0402436 },
  { lat: 51.4568266, lng: 0.0417456 },
  { lat: 51.4574416, lng: 0.0425824 },
  { lat: 51.4583641, lng: 0.0445136 },
  { lat: 51.4594337, lng: 0.0469383 },
  { lat: 51.4598348, lng: 0.047625 },
  { lat: 51.460276, lng: 0.0476679 },
  { lat: 51.4605568, lng: 0.0489339 },
  { lat: 51.460784, lng: 0.0492343 },
  { lat: 51.4617332, lng: 0.0497708 },
  { lat: 51.4645941, lng: 0.0511226 },
  { lat: 51.4671473, lng: 0.0526032 },
  { lat: 51.4690856, lng: 0.0540623 },
  { lat: 51.4696069, lng: 0.0543842 },
  { lat: 51.4699277, lng: 0.0546202 },
  { lat: 51.4718123, lng: 0.0550708 },
  { lat: 51.472494, lng: 0.0551137 },
  { lat: 51.4734429, lng: 0.0554785 },
  { lat: 51.4748329, lng: 0.0562724 },
  { lat: 51.4759155, lng: 0.056723 },
  { lat: 51.4772653, lng: 0.057517 },
  { lat: 51.478027, lng: 0.0581607 },
  { lat: 51.4790561, lng: 0.0592336 },
  { lat: 51.4800584, lng: 0.0600704 },
  { lat: 51.4815951, lng: 0.0612506 },
  { lat: 51.4822767, lng: 0.0617012 },
  { lat: 51.482584, lng: 0.0618514 },
  { lat: 51.4832388, lng: 0.0621304 },
  { lat: 51.4838134, lng: 0.0620445 },
  { lat: 51.4859112, lng: 0.0627312 },
  { lat: 51.4869668, lng: 0.0632676 },
  { lat: 51.4872875, lng: 0.0632676 },
  { lat: 51.4877685, lng: 0.0631174 },
  { lat: 51.48849, lng: 0.0627097 },
  { lat: 51.4892382, lng: 0.0624093 },
  { lat: 51.4903204, lng: 0.0621947 },
  { lat: 51.4916431, lng: 0.0615296 },
  { lat: 51.4924714, lng: 0.0609073 },
  { lat: 51.4930592, lng: 0.0609073 },
  { lat: 51.4933398, lng: 0.061036 },
  { lat: 51.493607, lng: 0.0608215 },
  { lat: 51.4939276, lng: 0.0608 },
  { lat: 51.4941948, lng: 0.061036 },
  { lat: 51.4946624, lng: 0.0609931 },
  { lat: 51.49513, lng: 0.0612077 },
  { lat: 51.4952769, lng: 0.0621733 },
  { lat: 51.4952903, lng: 0.063568 },
  { lat: 51.4959315, lng: 0.0642547 },
  { lat: 51.4967597, lng: 0.064083 },
  { lat: 51.4976815, lng: 0.0628599 },
  { lat: 51.4978418, lng: 0.06183 },
  { lat: 51.4976815, lng: 0.0606713 },
  { lat: 51.4977216, lng: 0.0599846 },
  { lat: 51.4980689, lng: 0.0595984 },
  { lat: 51.4987234, lng: 0.0596198 },
  { lat: 51.49867, lng: 0.0602421 },
  { lat: 51.4990039, lng: 0.0614866 },
  { lat: 51.4989505, lng: 0.0622377 },
  { lat: 51.4988436, lng: 0.0627312 },
  { lat: 51.4989238, lng: 0.0632676 },
  { lat: 51.4991642, lng: 0.0634393 },
  { lat: 51.4999123, lng: 0.063332 },
  { lat: 51.5000726, lng: 0.0633535 },
  { lat: 51.5000726, lng: 0.0638684 },
  { lat: 51.500126, lng: 0.0654349 },
  { lat: 51.5003531, lng: 0.0670013 },
  { lat: 51.5007538, lng: 0.0684604 },
  { lat: 51.5011011, lng: 0.0696191 },
  { lat: 51.5012747, lng: 0.0704774 },
  { lat: 51.5014618, lng: 0.0706705 },
  { lat: 51.5017823, lng: 0.0706705 },
  { lat: 51.5021697, lng: 0.0702199 },
  { lat: 51.5024903, lng: 0.0700053 },
  { lat: 51.5031447, lng: 0.0703487 },
  { lat: 51.50424, lng: 0.0708851 },
  { lat: 51.505028, lng: 0.0711855 },
  { lat: 51.5058828, lng: 0.0712499 },
  { lat: 51.5070314, lng: 0.0708636 },
  { lat: 51.5073653, lng: 0.070456 },
  { lat: 51.5074187, lng: 0.0699839 },
  { lat: 51.5077125, lng: 0.0695762 },
  { lat: 51.5082868, lng: 0.0695762 },
  { lat: 51.5086608, lng: 0.0698551 },
  { lat: 51.5088789, lng: 0.0704554 },
  { lat: 51.5095333, lng: 0.0706915 },
  { lat: 51.5110958, lng: 0.0707773 },
  { lat: 51.5123644, lng: 0.0708202 },
  { lat: 51.5133393, lng: 0.0706271 },
  { lat: 51.5138467, lng: 0.0703481 },
  { lat: 51.5142874, lng: 0.0703481 },
  { lat: 51.5147547, lng: 0.0707344 },
  { lat: 51.515142, lng: 0.0712064 },
  { lat: 51.515823, lng: 0.0718502 },
  { lat: 51.5168779, lng: 0.0723652 },
  { lat: 51.5185069, lng: 0.0728801 },
  { lat: 51.5196418, lng: 0.0731805 },
  { lat: 51.5203094, lng: 0.0732878 },
  { lat: 51.5209369, lng: 0.0731162 },
  { lat: 51.5219116, lng: 0.0727514 },
  { lat: 51.5228462, lng: 0.0724295 },
  { lat: 51.5232868, lng: 0.0723652 },
  { lat: 51.5237407, lng: 0.0725154 },
  { lat: 51.5240183, lng: 0.0726507 },
];

export const ULEZ_CENTRAL_BOUNDS = [
  { lat: 51.489296, lng: -0.130644 },
  { lat: 51.488941, lng: -0.129892 },
  { lat: 51.488762, lng: -0.129503 },
  { lat: 51.488663, lng: -0.129146 },
  { lat: 51.488319, lng: -0.128364 },
  { lat: 51.48711, lng: -0.125691 },
  { lat: 51.486916, lng: -0.125295 },
  { lat: 51.486748, lng: -0.124711 },
  { lat: 51.486561, lng: -0.123972 },
  { lat: 51.486496, lng: -0.12362 },
  { lat: 51.486401, lng: -0.123218 },
  { lat: 51.486279, lng: -0.122208 },
  { lat: 51.486256, lng: -0.121639 },
  { lat: 51.486263, lng: -0.120938 },
  { lat: 51.486389, lng: -0.119916 },
  { lat: 51.486782, lng: -0.11731 },
  { lat: 51.486897, lng: -0.116466 },
  { lat: 51.486973, lng: -0.115268 },
  { lat: 51.487007, lng: -0.113783 },
  { lat: 51.487068, lng: -0.113181 },
  { lat: 51.487175, lng: -0.11287 },
  { lat: 51.48732, lng: -0.112503 },
  { lat: 51.48756, lng: -0.112151 },
  { lat: 51.487904, lng: -0.111858 },
  { lat: 51.488205, lng: -0.11161 },
  { lat: 51.488392, lng: -0.111468 },
  { lat: 51.488544, lng: -0.111397 },
  { lat: 51.488972, lng: -0.110905 },
  { lat: 51.489216, lng: -0.110394 },
  { lat: 51.489357, lng: -0.109869 },
  { lat: 51.489841, lng: -0.108207 },
  { lat: 51.490025, lng: -0.107723 },
  { lat: 51.490536, lng: -0.106749 },
  { lat: 51.490749, lng: -0.10631 },
  { lat: 51.490856, lng: -0.105952 },
  { lat: 51.490978, lng: -0.105303 },
  { lat: 51.491199, lng: -0.10407 },
  { lat: 51.491325, lng: -0.103524 },
  { lat: 51.491447, lng: -0.103211 },
  { lat: 51.491871, lng: -0.102645 },
  { lat: 51.492687, lng: -0.101366 },
  { lat: 51.49292, lng: -0.101101 },
  { lat: 51.493214, lng: -0.100964 },
  { lat: 51.493416, lng: -0.100909 },
  { lat: 51.493622, lng: -0.100874 },
  { lat: 51.493927, lng: -0.100885 },
  { lat: 51.494606, lng: -0.100924 },
  { lat: 51.494736, lng: -0.100936 },
  { lat: 51.494911, lng: -0.101285 },
  { lat: 51.495022, lng: -0.101486 },
  { lat: 51.495274, lng: -0.101344 },
  { lat: 51.495461, lng: -0.10125 },
  { lat: 51.495571, lng: -0.101207 },
  { lat: 51.495651, lng: -0.101102 },
  { lat: 51.495693, lng: -0.100911 },
  { lat: 51.49567, lng: -0.100378 },
  { lat: 51.495621, lng: -0.100136 },
  { lat: 51.495537, lng: -0.099954 },
  { lat: 51.49543, lng: -0.099873 },
  { lat: 51.495255, lng: -0.099755 },
  { lat: 51.495136, lng: -0.099035 },
  { lat: 51.49477, lng: -0.097227 },
  { lat: 51.494389, lng: -0.095451 },
  { lat: 51.494228, lng: -0.094557 },
  { lat: 51.494232, lng: -0.094208 },
  { lat: 51.49427, lng: -0.091103 },
  { lat: 51.494312, lng: -0.088947 },
  { lat: 51.494354, lng: -0.087147 },
  { lat: 51.494354, lng: -0.086792 },
  { lat: 51.494419, lng: -0.086684 },
  { lat: 51.494968, lng: -0.086409 },
  { lat: 51.495106, lng: -0.08621 },
  { lat: 51.49485, lng: -0.084823 },
  { lat: 51.494873, lng: -0.084743 },
  { lat: 51.495247, lng: -0.084093 },
  { lat: 51.495598, lng: -0.08357 },
  { lat: 51.495865, lng: -0.083209 },
  { lat: 51.496056, lng: -0.08298 },
  { lat: 51.49633, lng: -0.082728 },
  { lat: 51.496494, lng: -0.082458 },
  { lat: 51.496765, lng: -0.081913 },
  { lat: 51.497158, lng: -0.080992 },
  { lat: 51.497353, lng: -0.080524 },
  { lat: 51.497513, lng: -0.080192 },
  { lat: 51.497631, lng: -0.080007 },
  { lat: 51.497761, lng: -0.079902 },
  { lat: 51.498768, lng: -0.079396 },
  { lat: 51.499699, lng: -0.078978 },
  { lat: 51.501392, lng: -0.078205 },
  { lat: 51.502117, lng: -0.077825 },
  { lat: 51.502357, lng: -0.077677 },
  { lat: 51.502457, lng: -0.077818 },
  { lat: 51.502724, lng: -0.07822 },
  { lat: 51.502895, lng: -0.078468 },
  { lat: 51.503101, lng: -0.078345 },
  { lat: 51.502979, lng: -0.077815 },
  { lat: 51.502914, lng: -0.077513 },
  { lat: 51.502937, lng: -0.077304 },
  { lat: 51.502972, lng: -0.077247 },
  { lat: 51.503769, lng: -0.076724 },
  { lat: 51.504444, lng: -0.076295 },
  { lat: 51.506718, lng: -0.074786 },
  { lat: 51.507065, lng: -0.074552 },
  { lat: 51.507149, lng: -0.074502 },
  { lat: 51.507534, lng: -0.074421 },
  { lat: 51.509197, lng: -0.074059 },
  { lat: 51.509277, lng: -0.07409 },
  { lat: 51.509388, lng: -0.074216 },
  { lat: 51.509605, lng: -0.074497 },
  { lat: 51.509701, lng: -0.074695 },
  { lat: 51.509747, lng: -0.074814 },
  { lat: 51.509747, lng: -0.074955 },
  { lat: 51.50993, lng: -0.075049 },
  { lat: 51.510052, lng: -0.075071 },
  { lat: 51.510101, lng: -0.075061 },
  { lat: 51.511124, lng: -0.075288 },
  { lat: 51.511265, lng: -0.075329 },
  { lat: 51.511292, lng: -0.074825 },
  { lat: 51.511303, lng: -0.073382 },
  { lat: 51.511311, lng: -0.073231 },
  { lat: 51.51133, lng: -0.073165 },
  { lat: 51.511383, lng: -0.073137 },
  { lat: 51.511589, lng: -0.073151 },
  { lat: 51.512249, lng: -0.073274 },
  { lat: 51.512939, lng: -0.07337 },
  { lat: 51.513191, lng: -0.073414 },
  { lat: 51.513401, lng: -0.073467 },
  { lat: 51.513779, lng: -0.073584 },
  { lat: 51.513958, lng: -0.073701 },
  { lat: 51.514114, lng: -0.073815 },
  { lat: 51.514259, lng: -0.073942 },
  { lat: 51.514343, lng: -0.07404 },
  { lat: 51.514362, lng: -0.074117 },
  { lat: 51.514355, lng: -0.074279 },
  { lat: 51.514469, lng: -0.074393 },
  { lat: 51.514572, lng: -0.074362 },
  { lat: 51.514652, lng: -0.074084 },
  { lat: 51.514633, lng: -0.073941 },
  { lat: 51.514656, lng: -0.073833 },
  { lat: 51.515106, lng: -0.072552 },
  { lat: 51.515224, lng: -0.072207 },
  { lat: 51.515278, lng: -0.072125 },
  { lat: 51.515335, lng: -0.072095 },
  { lat: 51.515427, lng: -0.072114 },
  { lat: 51.51561, lng: -0.072275 },
  { lat: 51.516426, lng: -0.073032 },
  { lat: 51.51712, lng: -0.073535 },
  { lat: 51.518261, lng: -0.074471 },
  { lat: 51.518394, lng: -0.074613 },
  { lat: 51.518635, lng: -0.074642 },
  { lat: 51.519176, lng: -0.074657 },
  { lat: 51.519688, lng: -0.07461 },
  { lat: 51.520111, lng: -0.074593 },
  { lat: 51.520283, lng: -0.074652 },
  { lat: 51.520428, lng: -0.074757 },
  { lat: 51.520695, lng: -0.075005 },
  { lat: 51.521091, lng: -0.075428 },
  { lat: 51.521648, lng: -0.076096 },
  { lat: 51.522034, lng: -0.076629 },
  { lat: 51.522362, lng: -0.077039 },
  { lat: 51.522629, lng: -0.077404 },
  { lat: 51.522717, lng: -0.077604 },
  { lat: 51.522846, lng: -0.078028 },
  { lat: 51.523148, lng: -0.078552 },
  { lat: 51.523621, lng: -0.079316 },
  { lat: 51.523716, lng: -0.079514 },
  { lat: 51.523628, lng: -0.08051 },
  { lat: 51.52433, lng: -0.080456 },
  { lat: 51.52467, lng: -0.081014 },
  { lat: 51.524902, lng: -0.081487 },
  { lat: 51.525173, lng: -0.082054 },
  { lat: 51.525593, lng: -0.082826 },
  { lat: 51.525932, lng: -0.083511 },
  { lat: 51.526066, lng: -0.083865 },
  { lat: 51.526134, lng: -0.084096 },
  { lat: 51.526154, lng: -0.084412 },
  { lat: 51.526161, lng: -0.084812 },
  { lat: 51.526154, lng: -0.085002 },
  { lat: 51.526127, lng: -0.085204 },
  { lat: 51.526028, lng: -0.085649 },
  { lat: 51.525818, lng: -0.086514 },
  { lat: 51.525742, lng: -0.086766 },
  { lat: 51.525642, lng: -0.086895 },
  { lat: 51.525364, lng: -0.087185 },
  { lat: 51.525295, lng: -0.087278 },
  { lat: 51.525288, lng: -0.087703 },
  { lat: 51.525475, lng: -0.088163 },
  { lat: 51.52549, lng: -0.088236 },
  { lat: 51.525612, lng: -0.088282 },
  { lat: 51.525723, lng: -0.088218 },
  { lat: 51.526016, lng: -0.087934 },
  { lat: 51.5261, lng: -0.087916 },
  { lat: 51.526237, lng: -0.087967 },
  { lat: 51.526451, lng: -0.088065 },
  { lat: 51.526814, lng: -0.0883 },
  { lat: 51.527142, lng: -0.088562 },
  { lat: 51.527287, lng: -0.088711 },
  { lat: 51.527393, lng: -0.088913 },
  { lat: 51.527534, lng: -0.089352 },
  { lat: 51.528168, lng: -0.091731 },
  { lat: 51.528526, lng: -0.09316 },
  { lat: 51.529659, lng: -0.097581 },
  { lat: 51.530357, lng: -0.100227 },
  { lat: 51.530773, lng: -0.101834 },
  { lat: 51.529709, lng: -0.102534 },
  { lat: 51.531097, lng: -0.104612 },
  { lat: 51.531456, lng: -0.105217 },
  { lat: 51.531654, lng: -0.105561 },
  { lat: 51.531742, lng: -0.105728 },
  { lat: 51.531803, lng: -0.106046 },
  { lat: 51.531822, lng: -0.10647 },
  { lat: 51.531773, lng: -0.108602 },
  { lat: 51.531708, lng: -0.109828 },
  { lat: 51.531513, lng: -0.111366 },
  { lat: 51.531292, lng: -0.114023 },
  { lat: 51.530163, lng: -0.115361 },
  { lat: 51.529968, lng: -0.115614 },
  { lat: 51.529785, lng: -0.115779 },
  { lat: 51.529381, lng: -0.115719 },
  { lat: 51.528728, lng: -0.118818 },
  { lat: 51.528561, lng: -0.119578 },
  { lat: 51.528969, lng: -0.119927 },
  { lat: 51.529942, lng: -0.120701 },
  { lat: 51.530178, lng: -0.120912 },
  { lat: 51.530277, lng: -0.121039 },
  { lat: 51.530361, lng: -0.121194 },
  { lat: 51.530437, lng: -0.121511 },
  { lat: 51.530499, lng: -0.121832 },
  { lat: 51.53054, lng: -0.122096 },
  { lat: 51.53054, lng: -0.122364 },
  { lat: 51.530499, lng: -0.122589 },
  { lat: 51.530319, lng: -0.123026 },
  { lat: 51.530079, lng: -0.123614 },
  { lat: 51.529709, lng: -0.124366 },
  { lat: 51.529045, lng: -0.126057 },
  { lat: 51.528461, lng: -0.127506 },
  { lat: 51.527973, lng: -0.12877 },
  { lat: 51.52763, lng: -0.129628 },
  { lat: 51.527187, lng: -0.130863 },
  { lat: 51.526237, lng: -0.133624 },
  { lat: 51.525719, lng: -0.135254 },
  { lat: 51.525536, lng: -0.135803 },
  { lat: 51.524624, lng: -0.134815 },
  { lat: 51.523598, lng: -0.137361 },
  { lat: 51.524715, lng: -0.138151 },
  { lat: 51.524765, lng: -0.138197 },
  { lat: 51.524796, lng: -0.138276 },
  { lat: 51.524704, lng: -0.13874 },
  { lat: 51.524467, lng: -0.139769 },
  { lat: 51.524277, lng: -0.14065 },
  { lat: 51.523972, lng: -0.142103 },
  { lat: 51.523861, lng: -0.142875 },
  { lat: 51.523804, lng: -0.143245 },
  { lat: 51.523708, lng: -0.14349 },
  { lat: 51.52356, lng: -0.143698 },
  { lat: 51.523365, lng: -0.144053 },
  { lat: 51.523251, lng: -0.144292 },
  { lat: 51.523926, lng: -0.144395 },
  { lat: 51.523941, lng: -0.144788 },
  { lat: 51.52388, lng: -0.145028 },
  { lat: 51.523758, lng: -0.145007 },
  { lat: 51.523674, lng: -0.145015 },
  { lat: 51.523514, lng: -0.145059 },
  { lat: 51.523415, lng: -0.145112 },
  { lat: 51.523254, lng: -0.145232 },
  { lat: 51.523129, lng: -0.145379 },
  { lat: 51.523048, lng: -0.145496 },
  { lat: 51.522957, lng: -0.14568 },
  { lat: 51.522861, lng: -0.145946 },
  { lat: 51.522808, lng: -0.146221 },
  { lat: 51.522785, lng: -0.14639 },
  { lat: 51.522778, lng: -0.146571 },
  { lat: 51.522785, lng: -0.14675 },
  { lat: 51.522804, lng: -0.146939 },
  { lat: 51.522839, lng: -0.147114 },
  { lat: 51.522896, lng: -0.147307 },
  { lat: 51.522945, lng: -0.147451 },
  { lat: 51.523045, lng: -0.147649 },
  { lat: 51.523163, lng: -0.147827 },
  { lat: 51.523304, lng: -0.147967 },
  { lat: 51.523392, lng: -0.14803 },
  { lat: 51.523216, lng: -0.149139 },
  { lat: 51.523075, lng: -0.150475 },
  { lat: 51.523014, lng: -0.151148 },
  { lat: 51.522968, lng: -0.151827 },
  { lat: 51.522888, lng: -0.152498 },
  { lat: 51.522728, lng: -0.153437 },
  { lat: 51.521988, lng: -0.157356 },
  { lat: 51.520855, lng: -0.156828 },
  { lat: 51.520424, lng: -0.159203 },
  { lat: 51.521576, lng: -0.159695 },
  { lat: 51.521034, lng: -0.162958 },
  { lat: 51.520699, lng: -0.16481 },
  { lat: 51.520611, lng: -0.165301 },
  { lat: 51.520161, lng: -0.165577 },
  { lat: 51.519833, lng: -0.16571 },
  { lat: 51.519222, lng: -0.165877 },
  { lat: 51.519012, lng: -0.166054 },
  { lat: 51.518616, lng: -0.166569 },
  { lat: 51.518345, lng: -0.166907 },
  { lat: 51.518227, lng: -0.167071 },
  { lat: 51.518112, lng: -0.167147 },
  { lat: 51.518009, lng: -0.167116 },
  { lat: 51.517452, lng: -0.166304 },
  { lat: 51.515427, lng: -0.163339 },
  { lat: 51.514755, lng: -0.162365 },
  { lat: 51.513817, lng: -0.160902 },
  { lat: 51.513378, lng: -0.16017 },
  { lat: 51.51334, lng: -0.160066 },
  { lat: 51.513325, lng: -0.159957 },
  { lat: 51.513515, lng: -0.158283 },
  { lat: 51.51218, lng: -0.157672 },
  { lat: 51.510761, lng: -0.156952 },
  { lat: 51.510513, lng: -0.156806 },
  { lat: 51.510277, lng: -0.156603 },
  { lat: 51.510044, lng: -0.156292 },
  { lat: 51.509895, lng: -0.15614 },
  { lat: 51.509651, lng: -0.155791 },
  { lat: 51.50943, lng: -0.155451 },
  { lat: 51.509117, lng: -0.155029 },
  { lat: 51.508507, lng: -0.154345 },
  { lat: 51.507755, lng: -0.153507 },
  { lat: 51.507191, lng: -0.152849 },
  { lat: 51.50666, lng: -0.152205 },
  { lat: 51.506393, lng: -0.151871 },
  { lat: 51.506073, lng: -0.151508 },
  { lat: 51.50592, lng: -0.15132 },
  { lat: 51.505714, lng: -0.151099 },
  { lat: 51.505531, lng: -0.150955 },
  { lat: 51.505383, lng: -0.150887 },
  { lat: 51.50518, lng: -0.150825 },
  { lat: 51.504944, lng: -0.150784 },
  { lat: 51.504711, lng: -0.150812 },
  { lat: 51.504589, lng: -0.150836 },
  { lat: 51.50404, lng: -0.151015 },
  { lat: 51.503933, lng: -0.151013 },
  { lat: 51.503773, lng: -0.150969 },
  { lat: 51.503551, lng: -0.150883 },
  { lat: 51.503452, lng: -0.150821 },
  { lat: 51.503403, lng: -0.150704 },
  { lat: 51.503391, lng: -0.150409 },
  { lat: 51.503349, lng: -0.150042 },
  { lat: 51.503296, lng: -0.149899 },
  { lat: 51.503204, lng: -0.149761 },
  { lat: 51.503094, lng: -0.149655 },
  { lat: 51.503021, lng: -0.149636 },
  { lat: 51.502663, lng: -0.149669 },
  { lat: 51.502457, lng: -0.149718 },
  { lat: 51.502285, lng: -0.149925 },
  { lat: 51.502167, lng: -0.150276 },
  { lat: 51.501949, lng: -0.150874 },
  { lat: 51.501896, lng: -0.151045 },
  { lat: 51.501831, lng: -0.151149 },
  { lat: 51.501755, lng: -0.151149 },
  { lat: 51.501541, lng: -0.150954 },
  { lat: 51.501247, lng: -0.150524 },
  { lat: 51.500954, lng: -0.150065 },
  { lat: 51.500637, lng: -0.149539 },
  { lat: 51.50032, lng: -0.149082 },
  { lat: 51.499859, lng: -0.148399 },
  { lat: 51.499596, lng: -0.148122 },
  { lat: 51.4991, lng: -0.1477 },
  { lat: 51.498447, lng: -0.147124 },
  { lat: 51.498367, lng: -0.147046 },
  { lat: 51.498318, lng: -0.146958 },
  { lat: 51.49828, lng: -0.14679 },
  { lat: 51.498295, lng: -0.146463 },
  { lat: 51.498299, lng: -0.145986 },
  { lat: 51.49831, lng: -0.145474 },
  { lat: 51.498302, lng: -0.145054 },
  { lat: 51.498257, lng: -0.144636 },
  { lat: 51.498203, lng: -0.144312 },
  { lat: 51.498138, lng: -0.143957 },
  { lat: 51.498077, lng: -0.143666 },
  { lat: 51.497982, lng: -0.143158 },
  { lat: 51.49789, lng: -0.142736 },
  { lat: 51.497826, lng: -0.142511 },
  { lat: 51.497723, lng: -0.142291 },
  { lat: 51.497601, lng: -0.142129 },
  { lat: 51.497471, lng: -0.14199 },
  { lat: 51.497295, lng: -0.141894 },
  { lat: 51.497017, lng: -0.141784 },
  { lat: 51.496738, lng: -0.141699 },
  { lat: 51.496597, lng: -0.141865 },
  { lat: 51.496464, lng: -0.142226 },
  { lat: 51.496433, lng: -0.14238 },
  { lat: 51.496391, lng: -0.142492 },
  { lat: 51.49625, lng: -0.142432 },
  { lat: 51.495872, lng: -0.142211 },
  { lat: 51.495483, lng: -0.141981 },
  { lat: 51.4949, lng: -0.141495 },
  { lat: 51.49432, lng: -0.140904 },
  { lat: 51.494102, lng: -0.140632 },
  { lat: 51.493935, lng: -0.140403 },
  { lat: 51.493755, lng: -0.139993 },
  { lat: 51.493031, lng: -0.138471 },
  { lat: 51.491882, lng: -0.136062 },
  { lat: 51.490978, lng: -0.134186 },
  { lat: 51.490349, lng: -0.132842 },
  { lat: 51.489296, lng: -0.130644 },
];

export const ULEZ_OUTER_BOUNDS = [
  'k}xyHaiGbDuBpD_CHj@AMDb@HXFPSBUDaDpBsCdBM}@yDzBEWvD_C',
  'svhyHbcyAIsG?mDDoAXsI]K?{@BwADqFBkCB}@J{GDaAJeEV_IX{HD{AZDBqFCKBcB^}G\\uGPeENaDHkBLgCTcFNkD\\_JXcHPgFb@cNb@aN`@wNRuINuEXgKH_CB{@NcFNmCNsCHaBZaGVqEx@cPNuDH[FO^q@JGt@QTKb@q@F]DkAE_@K]OWKOWS[EQAu@Q]IIfAMnDI`BEhBMjDIlCKvCKdDGlAGlBq@oB@WBaAHeDHmCHeDJwCHoBJeDHuAHwA[DSHa@\\I\\KVOz@?b@FvAHV@RGtIGdIEvGCpFKfEIbEEjCI|Bo@fSQvFQpGe@tOc@nNc@jOO~EeB~`@OhDItAYtGy@rOWtBU|BMxBXDGfAGpBIhBIzBc@~NC|@KbHCz@GzFE`EAhB@lACn@Q@RbICzBHfFDxBFhDJvDFzBFpBJzCNxGLtERfGVjFPfE\\lHXjH\\fHXnIDdDJ~J@`IKzAKnNMrGIjEE`AIhAKr@QjA[jA[|@]x@IKKYG]ESAIIMWIIICOCQAQCCEA}@PUDQEKKKIQEMAMFOJ]XGJCBGBIF[BKHEHCJAPATEREBECGMESIKMAWHIAKGQKIIIYCMEEICMDMAOIGAEDCRCb@@f@A`@ALEBKBOBGHILG?IAOIQKUWS]aA_AUWEOCMGGM@OJIDEAEEIMQo@OWCIAG@GBGDKFGDI@K?ICIEQAI@a@CMEMKKKEGAKBe@RICGCGIEICOCS?S@QBMRm@DQBSAQCOCEEEGCOCM@GDKFG@OAk@@WBK@GEKMGIGIKSIOKEIAWCMUZu@\\q@b@y@dBuCZk@x@cAPk@La@]UWn@]f@Yd@Y^[h@]j@q@jAu@rAm@nAGCGICMA_@CGECOCOEUCi@QIHg@EiAkACDADG\\GVEJEDEBGBG@K?GAGCKIYi@IGE?E@E@EBCDW|@C@C@E?mAe@GGAEKa@CCCCEAG?YHE?ECKGIIEICICGAO@MH]@O@]AGAGAECCEAUAk@G_CWF}A[HWEYGOAS@ONOHMXI\\Cb@Ef@MBUCGGMWGOAOEKGGQ@KDEFCNAZGROXWT[JSBKDKJWr@k@pA_Bp@UNc@Vg@@K@Ub@N`AGj@_ARkA~D[vBg@`BWl@ENGVAP?V?PBb@?HAJCPCREJCFIHC@YDk@TYDM@EAGCGEQ[KGQEi@?a@F}@Pe@NO?OGw@q@GCIEMCMAG?G@OJYXa@j@qA~ASXU^IRCFEf@CFABIJCDa@R{@z@URWf@uBHULe@f@i@NG@K?SC_Co@yAe@g@Qy@]OEIEKGYWc@k@KQGMUs@MWKQKKGGWIQE_@Ey@CK@G@KBKFIHGJGJGLCHIb@AHEHIHKJMDKDO@MAOCOEc@UcBgAUMKCWG[AwBNS?sDu@s@ISAO?O@UBSFSHq@b@e@T_@RWHe@Dc@BQAi@GOCc@QUMGGCEGQOq@IWEQKSII_@]_@_@WSm@]_Bk@w@UIA[Cm@G]uAIc@UwAQsAMy@y@mHCi@Cs@FkAPaBJw@RuBHu@DaA@m@?q@A]A]EYIa@WLO?g@AMKc@@e@Ne@Jc@T[JeA`@_@Fq@Ji@B_@Ga@HQAKl@@f@AJTDH?TG?Q\\Uf@?v@Mb@G|@Wt@a@\\Ip@KNHn@CBIx@ABLBbAAfAIt@{@rIEv@@`@Bl@Ft@Fr@\\~CVlBRzAPfARhAZrASJeAz@_Br@yALy@Na@Co@Rg@VUN_@RSHOAm@AoAD}@b@s@bC[Hg@OeAiAu@YU?CDCNEnAALCJCFGJMLIDGDSF_@@y@d@oAn@i@f@[l@Qz@YlAO|@Kx@Qf@a@ZMFSJo@Lw@d@m@XOH_@^IHi@x@IJa@\\IJSZEDEDGBSBU?MCCA]g@EKIIQOCGO]EGIMYU}A}@oB}AWQUMUI]OPmDBu@@y@B_BGgAEiAIg@Gq@Kc@Wi@OY]a@cBqB]]SWIM_@G}Am@uAo@QQGQQ}@[s@]_@eBaCo@eAKu@A_@G}@GgAMaCEu@Ey@CgAAeACy@EoB@WR[Zi@|@wADERuAIYu@yCe@[I@W?Wr@[~@a@nAc@dBIj@Y\\iAn@YR}Az@kAf@_@LQFIBKAMAOKGGu@}@c@[G@K?[FINOZGPAVGHELIBuBEg@Ay@H[@QDOJSLQPy@dBOj@Gx@EXIXc@lAOXAG[_A_@o@MOI?g@SAGDUWQASDUWMCg@HcCDu@qBwBeAqA{@_AmGkI??cDmDh@oA{@uA?APS?E?EAEKSQUEEQCCCECAAAEKWEECAG@G?IAYSMEK?OBGDM@KA_@?qAMUI{@i@UQOGS?u@FgAOWYKEO@MJ]Jc@??RCJOJ[FUQGYCGqBRLkCRqFHgBZuDNoAH{@RcBRaBf@mDh@yCF_@Lm@Bs@@s@?I[{@WUKKQCM@SBg@FMn@CNG@KBuAc@IH]Wa@[[SUUyCsCsAqAa@a@YYs@{@c@u@[_@Q_@Wo@_@y@c@y@YgAa@oAsAwC[LGBWZ?FIJQ`@{Ab@yBl@m@H}MxCwc@lKkBd@e@b@[V[p@Sb@s@pCI\\QVeBl@{Ap@_Ab@}@`@mAf@SFYHY@]@]AWC]G{@M{@MM@k@AQ?e@FaIvAOBe@Fa@?cH{@a@IYD]J[HUFSLMDWVQLWXa@n@iIrM_@t@o@`Ak@bAYn@aAzBmAvCa@dAa@dAO`@Sb@Uf@g@p@uErGi@x@W\\q@lAY\\QXTb@h@lAL`@d@pAn@~A\\v@b@bAVn@Vn@Vn@Rt@Rr@ZjAVfAbBnGnA|Ed@dBNj@dApCz@~Bn@`B\\bA^~@Tl@Xt@Zz@Xv@r@lBp@bB^`Ab@|@Zf@T\\LT]z@e@nAMVMROPMNONa@X}@d@]JOBSBS?OAm@GeAUi@EU@G@[L}@p@ULGBgAR_AXKDm@VWPMNMPKPKXKd@CJCFEDEDYLIFo@v@[ZYT[TsAp@g@RODe@JI@m@Jo@HMHGTAl@En@AHAJENGLEFGDGBMCKCKEa@SUIUEOBETC^?d@?JAVCNELEHIFIFG@G?I?MEWISKGEEECGWk@MUIKIKIGOGGA[@GA]Kg@Go@MOCe@Cy@?K@IBIFKHED_AvAGJKHKHMHMDQFM@m@Do@BwA@u@R}@\\mCbAsCnAUHMBM@S@Q?qAK_@BY@[F]L[RWRE@I?E?a@[i@UqAUKCWQGEEGCIAIGc@C[?s@@q@@_@@a@BYJ]f@cAJYDYHeABYAOG_@Sg@Uo@EO[e@OOECKCIBOHICUKa@W_@EMBI?KIQ[GKI?KDKHIJGHSb@Uh@OVMLMJOHIDSD_@B_Cj@[B_@EQCOG[QOEK@E@gAp@gBl@w@Rk@R[BcAF[Di@PgB|@UHIBO@c@CYDWFMJINWd@Od@EDEFKFKDK@M?ICKIEEGMQa@_@}AGKCEKCE?G@MDw@`AYf@GFIFE@UC}@[MAq@L]JK@GAKAIEKIKKEGCEO_@EGGGKEMAI@[JMBYDKAWIiAk@WOi@]_@UUGYEM?O@c@HO@c@@QASQUISOKYGg@I[c@QqAY_Aa@wAa@[Mk@YkBiAKEICIAGAk@BMAMCi@Q_@IWKGE_@_@MI_Bc@YES?YBQDKDMHGD]b@o@h@a@Ba@HYFY^Yp@Wn@Wr@GJEHEPOx@EXIt@K~@QhCQj@KZSZa@h@wAhAs@j@k@BUEg@Sa@C[Bk@Ng@@}@Ke@Ue@a@}A{Ck@g@_AYi@_A_AoAg@Sc@Q_BUs@ASBUNw@nB_AnAUt@[h@[P_@j@{@x@u@dAQPa@LWGMKc@mAYYm@Gw@AMAWEYOQKQOSWU[aAmBIWMk@Z_@Xa@Tc@R_@Vc@NWPOxAkA`@W`@Mn@OT@z@JZALMPSdE_GTe@Na@Vu@Ts@XeAN_@RYFCZDDF|@|Ar@jAb@d@VVl@t@HBJCHEHS[a@oAuAY_@y@sAq@iAIKs@KYRQTKTM`@W`A_@fAOf@_@p@gCrDu@dAUVKDQCa@Gc@C]FQF]FWJ_@Zq@h@_@VUPIJOVOVc@r@Q\\k@z@IFWg@_@g@Uk@Oc@K{@I}A@m@Lc@Z]XWl@i@Ja@?QAe@@SR{@Aa@Cg@?WFUHUj@iALMVKCUO]Ca@PcAJk@Au@Ms@_@yAfBqAnCqBvD_DdAu@x@k@|@w@X]\\e@J[BEr@}@\\m@Tg@`@_A^aAXy@Vy@ZaAn@wA`@oAt@mB~CmIZiBx@kBTgAVk@Xg@f@aBTk@pAyCjBuE@QVeAf@_CTmALu@Tm@nEqGvAgCnA}BjBaCl@oATg@Nh@`@bAf@bAb@v@h@v@nAvA|@~@XZNPLHVJLHNBVAZI^K\\ONBXPb@b@VJz@p@`AXRLl@Vp@Rt@VtA^T@XFVDV@VAR@PC`@Eh@JRDd@Pd@Nb@RPHRJ^Tr@`@l@`@r@`@ZNz@n@fAz@n@b@|@p@z@n@l@n@\\d@VV`@f@l@f@b@Tp@T\\P|BhAb@R`ARb@Pj@PlEzAlA`@~Ar@FL`@VRw@VcA^gAXcA^mAFQPi@^oA]_@U[M_@Oe@YcASu@w@{CQo@a@kBOw@_@kBMq@W_Bq@_EKu@iBgLG[Ks@Ki@OgAOw@Iy@S{@Me@Oe@QUSS][_@[[[u@s@a@i@Yc@KQOU[k@_@k@q@mAa@i@e@g@oA{AsA}Aa@e@i@k@]a@SUY[s@kAi@}@g@w@a@q@Wo@Wo@g@eASm@Oi@Qq@iA_GWsAWuASmAGUCeABuADcADq@Bc@F[Hi@`@sBFIKw@_@cCMwAMs@Ii@Os@Mc@i@}AwAmEuAoEy@oC]mA]kAa@}AMo@Pg@?IFWLY~@{Cl@{BHg@H_@@c@@m@EkFEgBAkA?_CAe@GsBAY?UHcCHeCKUc@S{@i@e@[UM[MSQOSoA{@q@e@\\uArA_F^iA^mAJYf@w@j@eAb@y@fAkBZy@d@_Af@kARi@Tq@Rk@Vm@n@sAl@oAl@y@ZUz@{@RIx@}@]}@OWU{AMq@O}@QeA?a@AuGAaAE{EAw@CaA?CEsAEqAAy@D_AF_ARcBf@iDLaA`@aDJ_AFuADs@@mBIs@OkBGs@Eo@Co@@a@Ac@DeA@eAFy@Ba@TyAHq@Po@N_AXkAb@qB`@mBNo@s@]o@MaBc@u@YYKw@c@][c@a@y@kAm@cAYi@_@iA_@kAWm@[eAaAwCSm@DGTm@XaAJgABwA@_A@q@DmABq@B?BQFi@Fk@D_ABo@DgCBaADkBHyCDaBNqHHsCBkBB{A@oA?{@Ck@Ii@CWEc@EcCCq@Cs@QqAIe@EYIa@Mk@E[_@sAOg@g@}AUmAGa@OgAQiBCQKa@EUCKWyAMm@MaACOMoAEm@G_@Ce@M{@Ks@UsEWsEAu@CcBSqDAwAEuGw@{GSgAk@kCcAsE[u@gBwC]s@Qc@I]E}@BqFCWOuA[yCOiBCkBEqBOoAESGSSiAOiACa@SkAKw@Sy@GYw@oCWsBcAkH]yASs@YaAk@uBIWQ_@Qi@e@}AgA}ENKLMtAaAnDgCz@k@^a@PQNS`@q@Ta@Zy@Ru@Py@Fk@Hq@RqALgAPeA\\qALQTYn@y@RQ]m@QUo@}@_@i@]k@kA}A{AmBg@o@w@_AeAmAUSSIOKMOQQSc@[k@{@s@u@o@IK[_@m@w@QS[a@QYO[GSGOEQI]Ka@O{@Io@Ca@Cm@DYDSVsA^aBLi@Nm@f@{A^sALa@PsAF}@JaFLoGBs@?m@?U?a@Ai@A{@@_AH}A@c@?o@@{@OyJQoNBw@WMSCQGi@MaA?SOIGYL?EGBAHgA?o@DSDSD]HQHWJQJSJYPULKFWN_@RYPKDG@G@I?GAGEMGOMKMIK[_@W[_@i@q@{@u@eA{@eAyAmB}@kA_AmAm@u@y@_Ag@i@WUcAq@i@Wc@Ue@Ua@UwAm@WQ]]}@oAw@eAuAiBo@{@}@kAb@uATu@XcAX_Al@uBXaBT_BPiAT_BRwAe@OwAt@aB~@i@V[Jq@VcATQ@cGNk@AGGg@?]CF[Yc@iB}C_@m@q@wAi@eAWg@MY?AAGQ_@GQAGGICGCKCGM_@CIOc@CKQi@Ww@_@mAc@sA[cA[gAAO?GAk@Uq@Se@GYg@yBCQCWQyAE[Ea@E[Ie@E[Gk@E[I{@Ga@Gm@ESEOASGw@OaBGk@AKAICKCMAIAMAIAKASCMAGAIAKAUCMAMEYCMAGCM?CCQAOAMC?AECKEOEMIYGS?GCKCICGGOEKACEUAEACAEEGCIEGEGGKACIIGMCEEEKEEECACCAEEECCAAEEOKEAIIEECAIAGEICGEEGEEE?CBG?GAECGGEEMIGGU_@y@iAxDyM~AeGZqAj@yBXoAh@iCdAqEFo@VqAn@_DJi@DUXyAVqANs@DQHa@He@Jg@Hc@F[He@Jk@F_@P{@Hi@DUF_@He@Hg@Fa@H_@HW|GbDh@A\\Bn@It@Ep@Iz@a@jAs@jA{@vC_C^_@pGqJlAuAdBkB~GuHpAwAtBgDpAmBnAyA|CuDvBkC~CmDpImJf@MDJp@a@Ak@BIKe@OUK@GIQPUT?TmGtHGN_DlDu@t@c@b@mCbDmAtA]^kAtAg@j@e@r@mApBqAhBeAtAoBvBaDlDcCbCiAzAw@~@oDnFw@hAu@t@[NYRa@\\SL_@Va@Z[RUNWNSNEBC@IF]HuC\\w@OoGsC^gBJi@RcAdAcDn@oAbBeCTSjAaAn@w@|@c@n@c@b@[xCiBj@e@dB{Ad@o@j@u@jA{B^u@Tg@Vc@\\m@T_@b@y@LSRa@xAcCnA}BNYfD}FHQ^q@r@mAP[^o@d@u@Zo@Zi@f@y@|@}An@gAj@{@`@q@Zc@d@u@f@u@b@m@Xa@Xc@Xc@NYR[BETOHCRG\\?RBHBRe@Re@Dc@IaA?]CQWa@e@U_@GIVOPINGNGTEPCT?P?XAPCNIPMVWb@U^SZSZY`@U^c@l@c@n@cAzAm@bAg@v@g@z@y@tAo@jAQZ{@pAy@pA_@l@iAvBsB|DoBhDa@n@Y`@M\\EV_A~AWb@KREFEDEDe@`@a@\\KJ]d@Y^S\\[j@Wd@WZQRST[ZYXUPYRq@x@{@n@qCn@i@?UASEo@G[E{@EYA]Bg@PJ}B@aBD}C@cB?aAAcBAoAEcCGmBM_DMmCOwCm@sJYiD[}Do@oGg@oE[eCc@mD[yBg@kDk@oDc@qCSoAWgB]uCKaAIgAKqAKcBMsI@cHFwBFaBJsBRcCNyALsAVyB\\oBV}AZyArBi@hBcA~CyBvByApBuAxAkA`@_@l@i@r@q@pBwAhDiCrDkCbDiCpAeAx@m@|BeCEOiAkD[FkARoALkAP{@LsB`@{@VaAZmAbAmCjB{@t@m@l@eAjAeAbB]f@Wp@Ih@?NErCHXg@Ya@_@sA\\o@w@qAyCMOg@@MTUfAqChKOj@u@xDi@vBe@`CQpAWhBS|A]nCYnDcB]MHCBABABCHMh@CJ?DC@UBU@O?I?GCUGEACCGEGCCACAIAGCIEICGAEAWOGCUKMEOICAKIEEMGKGOGEAGCIEECEEECIEKKMIIEGAQCUESEICUIGCWMKCYIO@U@EB?K@M?MAi@?K?GAo@@U?W?UBk@?c@@O@M?O@I?K?M?GAO?M?O@WA??]Cq@AY?K?KAK?CAGMe@Qo@FCCUAYCy@AWK_ACWAEAESBwAPW@g@BM@_@CQ?GAYEOCGo@QaBQcBKaA?CFeCBkBD_ADUH_@D]CIHUl@y@g@YHc@iAo@@EcC}AN_A@GPe@HQ^m@Zo@Pa@Lg@JWLSRUX_@HGFCNCb@ALCPK\\WJE`@OJGHIPYXs@Ng@DSFYJy@TwANkABc@FcAF@BAFm@Dm@@MBUF[Ji@@ENm@H[DUDUJe@@IRm@C?]Kc@QOGMIQISKKISMWSYU]UIIIEb@}A[iAF}@HYfAsCh@eAb@eAfAaC`@kATaADm@ViBFq@B}@HsFFgB@iAFmQE{@Ia@}A_EUo@g@{A[o@k@iAcAoBYg@sC}FECSSQa@OWSa@a@y@Qi@sAeCs@{Ae@eA]eAUo@[iA[cAe@sBSw@c@gBkBwFk@gB{@aB[c@cAaBSs@aAwCg@mB}A_GSk@_BeESs@k@eDOy@Mo@m@mDYqBQ{AIyBCyAAq@Cy@G]Me@_AwA]g@{@mAcAiBSg@mBuDIUq@mCGQYZWNC@KNADEJ?b@`@`JEv@q@fBU\\_@f@e@`@c@^{BnA_@NwBbA_@PUJOJ[POP]\\OLoAvA_@b@a@j@]l@c@p@]r@[d@W`@[`@m@wA]b@Si@MYKWACUo@Wu@q@iBUm@_@gAUm@Sc@Se@Sc@]_AIUm@gBGOYw@q@qAISKUMc@GSCMCIe@aAe@iAIUGQCKG[Ms@CSCUx@]f@UZK@AHIQeAgA{FM]c@qAm@aBa@mAs@iBq@gBi@wAe@oAIMEQGOEIKSCMEMBKHOHKFMHKPYPW\\]PORWHKLUFEJMJK?KIUGUIWK_@g@sBU{@YcAS}@Sq@Mg@Qy@WeAI[Mq@ESCQSiA~GgEvQwLf@a@bBoAh@k@`@g@Tg@Ra@Vm@`@aAXs@Te@Xm@P[JMD_Au@Gg@GUEUGy@Qu@_@q@[o@]i@We@Ua@QiAi@k@Sq@[a@Sq@UaCaA}@[qAe@g@Qu@W{@Oa@K}@O{AMg@FOAg@FQD{@Nq@F_@Bi@@u@Es@Kw@Qc@OwBy@o@o@mAoAa@]{CaBs@{@OQa@g@g@e@a@i@Ya@VaCVeCfBfA\\VRHbAl@n@`@BDVLr@`@JHNFBDBADFF?PLPJFFB@TJDDNJ^PZRB@j@gF\\qDT_C@UF_@NsANyANoAJg@H]FWJ[JYJWLUHMPUXUZWe@_@s@m@sAeAkA}@u@k@q@g@k@e@cBwAaBmAi@a@]Y}BkB{@_E_AoEEaDSsME_CKSmC{EaByCuAeCkBcD_BwCgAmB}@}A{A^PeGrA_g@XwKBeAbAe]DeAHsCOaAiAr@w@`@qGnCsKdE{@\\}GfCeSzHi@^UMgBcBuEuEoKEUGqBKkB?g@DlF}PRo@Tg@lBwDZk@j@eArBaE\\}@Ra@Ri@HUZ{@|@{BNi@Pc@Rm@HUn@aCTiAFs@\\eCPoBNkDz@}]B_AFw@@SHaABU@U?S?QAIG{@McCo@eI{@_LbCwZHi@Lg@xAmEjLa^p@sB~@uC|AyEl@_BNa@p@gAb@kAx@aDVaA[WiDsAKQQQg@aAYi@aAoBK]Oq@]oAe@uBIc@a@gAm@eBsCwG_@mBES[gAs@yAOQMQgAeBi@y@Q[Uk@c@iAwAyDc@}@Y]YWOGWGsAY}@OoDq@uAYcDg@kB]EC@Q[A[@aJfOSVeFhGAIEYGWEWIe@G[EWI_@GWEUGUEUI[I_@Qo@Mc@Ka@So@YaAUu@Qk@So@Qm@s@qCYcASeA_@cBQ{@a@iCM}@M_AS{BI}@OmCKeBEuBAu@?e@?cC?[?g@Bw@BkADkA?KFsAHuABOHkAJgADg@Fg@J{@J{@\\wCVaBV_CVuBRqBZ}CJeANsBLuAP_CLmBJaBJiBJ_CL}@F{BFcBDoABuA@U?U@e@@]@y@BcB@i@Dq@JmAHoADqABk@D{ALkBJyAYk@Kw@Iw@KiA?O?W?U@SBk@Bq@D_@DSBKJWJOHKHKHGFEFiB@_@@e@D{BDuBDiBDqBDyANm@Pu@Pk@\\iAL_@OGCEAG?IBSDWDSDQL{@Hs@Rw@TaAPo@Rq@Ro@xBoHRCTu@V{@Vu@b@yA^gAVu@^eAZ}@ZiAd@}A\\oA^qAVeA`@eBV}@Ty@\\iA^mA^qANg@Pi@Nm@XaARw@Nm@XsAXyAR_AX}ARqA\\mCH_ADUBYFm@D]Di@D_@Bi@Di@Fw@@WDg@F}@Be@Dg@Bc@BeADeBDiC`@PXRLFRRJLLRZd@Z`@PLRJ\\PrDz@l@PHeABe@BuALmCDu@DMFGxBDlABr@DLH@cAAK?aACuCEuBAe@Co@EYE[Gi@G[CE]aASg@m@aCE[E[Cc@G_AEi@Ei@EYQq@IWM_@Yu@a@eAEMGSOo@ES?GK_AAo@FsADeC@iAAo@A_@Cm@G}@GYMaAOeAKu@Im@UaBi@{DKs@Gg@Iy@Cc@Ey@A]Ca@?UGgAGiBCc@EgBEyACaBCaB?c@@[Ds@D_AJqBHmARaDFaBJeAJu@XeBh@sEVaDLiAX_AXuAPk@IU}AKe@GsIsAF}CHoG@eDHoCB}@HiCJmBHwAHuBLyARBj@qGJ{AVoCH{@P{BNoBHcBDkAJqBZoGJuCPgDF}BCsFBwCD_DLsHFiCO@ByC@wA?m@bAA|A[NCrBc@dBU`BS~B[zAMb@EDAl@Df@Rn@LNBjATt@Nn@Lf@F|@HbFf@zGr@dCJL@L?J?LA@?LAL?JCLAJCBAFAFCFEFCFCFCBCnB}@|@s@FADADCF?DA@?DAFAD?F?D?F?D?@?B@D@B@B@D@BBD@FDD@@?NHLHNHNHFDDBDDDBDBDBD@?@F@DBD@D?D@JBF@XDXD@@\\D\\B\\B\\@\\@\\@N?pGPbHTH?H?H?HAFADAHAHAFAHCHCFCHEFCFEHEFEFEDGFEFGFEDCz@u@b@]tAwAt@eARYHKFIFIHKFGHIFGHIHGHG??HGHEHGHEHCJEHEHCHADAHAFAHAFAH?F?H?H?F@H?F@H@D?HBH@JBHBJBHBHDJDHDDBhI|BtGnBB?dJrCtHxBHBHBH@HBH@??H@H@H?B@J?H?H?J???b@Ab@A`@Cb@Eb@E`@GtCQtA@tBDtDh@^DrGf@B@pEb@@?@q@G?YkAEWBqADeA?I`FlB\\FpBBnCE\\Dz@Vl@N~Bx@VH^D`@?`@Ch@Mf@Qp@Sd@MZEj@@pEl@b@BlATj@LpCx@d@J~Bx@b@JjDz@j@NP{@`@iB@EBGDK@EBG@CBEN[LWXk@Zk@DMHSJQP_@h@w@zA_C|B_D^c@fAoAd@{@\\aA^wA`AwF`AsGNcAHuAJuBNiCHgBBq@P{CLuALa@FSTs@Vi@NSj@u@`@a@h@u@^a@a@yAGGGIGIYq@c@{AQq@Qy@I[Gm@CWSkBI_Aa@gBSq@yAgGSm@Oq@}@kDOk@}AeFc@wAUm@Qm@Ss@kAqDEMGWCWCs@Cs@HmMBg@?}@DgABQD_@Fa@DYJe@Hc@BQ?G@M?K?KAOEOC]q@}CKcAGy@GiCI}HGmF?o@GcBMiAWkBQcBWmA_@kBMq@Us@YaA@C@C?E@G@C@EBCBEBCBCBAD?F?H?FADEDCBA@ABADAB?DCFCHEB?B@FDLFLDJFLHRJLFD@@BBFDHFFD?HGDCDCD@D@FBBBDBFBB?DADCB@DD@B@HBL?F?HADEBCBG@E@CBCDCBAD@DDFHFBBBF@@B@N@DAPIBCDG@EBUBCBEBADAB@@DBH@J@H@PBJ?F@BAF?FAH?N?D@D@DBDBBBBB@B?@ADC@E@IBC@CJG@AFGBCB?@@NLBD@LBFBBD?DADABAD?@A@CDO@C@?FAD?FAF?H@D?FCF?F?B@DB@D@L@L?@B@DCDEHKDED@DBXLDD@BBL@BBADABIBI?M@K?E?EBCB@DDDJDF@FBJ@P?X@F@@PDRFBABA@GBC@?D@B@DBBBDFL`@JV?DALADAF@JABAFCFAFAD?DBFBDDBD?B?DCDCPCD?@?B@JTHJFJDHHDF?FCHIBAJBD@BD@H@F?HAF?BADIZ?B?D@@D?J?FIBE@CD?B?@?@BBJDPBLDHHJDB@D@BAJAN?FAFEJEDGHAB?D@D@BFD@@@?@C@C@AF?HAFEFCHAF?BEBA@?FDBB?@?J@D?@D@NTFNBB@?BADK?AGSBIBIDGBIBIBGBE@ERm@HQBKBGDIBIDML]To@DOFOHOHWBIBKRi@b@kAh@uAZZt@f@l@Xf@v@\\tA|CbKTp@n@w@p@o@bAw@b@Yd@[RI`A[rAc@b@MLIpAUd@IfB]f@MpBi@xCiAp@a@v@o@d@g@bAgApCaDVc@Rs@b@aCFe@TeBcEaBc@O{B{@w@OKAW]OUgEuEa@c@qB}BcCcAf@kEBw@z@uA\\m@Zk@V_@TYZUtDiE`@a@TMFGh@w@NWbB{C^e@v@}@PYf@s@`A_A|@gAh@aAJMD?F?XFNBVCV^HT`@vAb@p@Vi@^mAn@sAXi@u@iA~AsCXi@LUrAgCRu@g@_@Jc@PaAJFVi@HFFDFBh@q@Ga@KeA?CCUh@e@^_@IUMy@]kCQqAIq@QkAMk@U}@W}@Uy@YeA[q@U]OMWSa@UECICSISE[?]DA{BK{CSQq@iFWeDSgC[oCc@kEWqC@a@TSB_@?c@bAaA`@i@FGTQBAHAF@THLFXPRDF@PEHKFCD?F?HDFFHLh@xAHLBDFR@J@NANAJCJMZGHWZILIPERETCVCb@A\\@f@@L@HFPLTBJDNRpBBl@P~@BFFLNNNLb@VLJNPNVLTHRRx@JVJRJJHFdAr@h@TPFNDL?L?`@IB?Z]FCDAL?FBHHHJP\\FJHHHFJDJBH@JALEJKHM@Ag@e@U]M[AUBSH[pAiEdA}CbAsCTw@FOn@nBb@tAr@lBp@tAj@dAj@z@d@n@d@n@h@b@j@d@p@d@jAh@t@Vv@Rh@D\\BjABf@@v@Gv@Kd@MZI`A]tAk@p@WfAc@jA]h@Mx@O|@Iv@Dn@J|@R~@Z`D~An@\\l@^p@f@z@p@r@t@r@t@j@j@t@|@dD`FrIjPn@fAR\\Xb@\\z@d@z@d@l@bArAd@f@h@j@XZt@j@`@^ZXn@`@`@V\\RHN~@jBr@bCFNRxAF`@BbA@t@?t@G~@E^Kn@Qv@Y~@u@tBg@jBo@hCOl@S`AQjAQ~@Kx@QhAG`@Ix@Kr@Gf@Iz@QtAMlAE^OtACZOnBEj@Et@Er@AXWICb@AhBA`B?rA?hA@b@BbBDx@Dx@LtAJfAV~BLlAXjCVxBF`@Hp@JhALtADj@LbBHxABz@D~@@ZBfA@~AAtC?~A?dFC`ACrACj@?DAHAHCREJIxAKd@QTw@t@u@PM|@Gn@CbAJVl@hB^x@RTZNl@HPQ`B_AR{@HYRq@i@iB[iAEg@B_AFk@FuAHmB@oB@w@@a@CsDA{AKcD?_@Cs@EyACk@A]KkBK}AEi@G{@SaCCQES]eDMoAWoBWwBMoAKgAI_AEk@GeAAQAk@C_A?q@@cA@{@Bw@Do@Ba@Be@J{@NcAUK^aERiBBUHi@Hu@DYPcAHe@Ls@R_AJm@VkAHc@VmAF[FYDUNm@Ns@Po@Ja@La@Ne@Nc@Pe@Pk@Nk@Je@Fa@`@o@Zc@n@{@j@y@p@o@h@i@`@]zCeCj@h@h@\\PJXNVNZJx@Tj@F`@?d@?P?`@Gd@Qd@MZO\\WZWZUf@m@PSpBmCZ_@\\c@`@a@VYj@[XWb@UPK^MTEf@MZGlBMtCOpAGl@C^ER@f@Cb@Ad@Af@C`@Gr@Kb@G`@Mf@Ml@Yj@Sp@Sp@[l@a@f@UbB}@rAu@`@UFCNIt@]XOFCPITM^QXOn@O\\SdBgAtAw@bBcALANRHe@dAn@HFHJj@JTGh@EZwAz@oDNo@IcAGe@Oi@Wc@SMMAUEg@FQ?c@Ny@j@q@rAQh@[j@MLoCjBgJbG_@Xq@p@aAf@_Al@iAp@_Af@g@ZqAj@k@TWFcEh@c@Dg@Ce@?[?WAc@?YAa@GaAGgAKqEE{AVc@DUDm@Hq@L[F_@J_@JUFg@Ra@J{FfBwA`@a@JUBw@LcAFw@?m@AeAIg@Gi@Oe@Iq@Oc@Qe@S[O[Ss@g@UQ_@[[][W[[o@o@OWY]g@s@cA{AcC_EeAaBm@_A[i@i@eAQYIQMUo@_Bq@yAUi@Sg@Sa@M]QWOYQWW]SYSUc@c@QQWUYQa@Ya@Q[Ug@UgQqGg@Qg@O]MQESEMEOEOC[IYE]E[Cg@AY@O@Y?GBI?]Ho@FWDSeAeAf@iA`@]\\KBSF}@Za@L_@Nu@Vc@LKDWDa@DWBY@q@?]Ci@C]Eg@MYIa@Og@U]Sc@]a@[}@aAw@cAcAgBk@qA]}@[_Ak@cB_@yAHYRk@DIr@}An@}Ad@oARi@p@}ATm@Vs@Rc@h@sARg@Pi@^sAb@{Af@_BRa@FWDOL_@Pi@b@Vj@b@fAfA^\\z@`At@`AnA|B~@`Bj@dA^ILA??TCPWOeCI]U}CWsC]cMA_AOsECc@Am@IcA_@qDUmBPm@d@_BVy@L_@ZiABGBIFKP[Xe@?A?A@EJqAPqBHeAJaAHcA@G?ELk@n@wCd@oBNq@P}@Jc@BQD[Js@Hm@PuAPsADUD[Lm@\\{Az@eAfAmAfByB`@e@rCgD^c@bBeBjAs@z@m@pBwAn@a@NQXWz@mA`@]Zo@zBaDzB_DvCaEfOoRf@e@PYTg@Na@Na@J[Na@NWJUFGNTHd@BHZJ\\VLGHBLo@Rc@AQ@[@OKe@Wa@QCGG[JSNKXc@JYXq@rAa@tAURWCW?}MoAs@Ie@EiBIe@@s@Di@?y@FgALm@BmAPi@BiALyC\\W@e@JmAPsBU[GWCUEQAE?O@SD]Lq@Nm@Nq@Pe@Ng@Pe@LoA`@c@L{C`AB[XeC@{@\\gAJ]@A@E@C@A\\]NURYJKVa@PUJOJO^e@z@gAd@y@TYLWTYSi@Kq@U}Ac@yCa@n@[o@QW?GY{@EUIi@QkAKq@G[MqAIk@G[G[ACEUCQESCYGOCQKk@Ie@AGEYAIMHm@\\eAl@kAr@e@XcDi@cCkAs@]G?AEk@[eAeFC@GWCESUKKQKKEOCSAUAQ?S@[sBOJYRc@Xo@^gAp@qAv@g@Z[TUT]Za@d@_@f@QTGLYj@Ud@YuAMq@s@sCu@yCQk@{@uDIq@m@{DKy@[mAQs@g@kAdBkANKNM?@p@c@j@a@?Az@o@z@m@zAgAtAaAHG@AOaAi@qD@?c@wC@As@aFrDuAc@yCi@wD[{BWiB]_CSiAW}Aa@}Bm@iD@C@A_@kA_@sAQi@Y{@Qi@y@oCeAgDmAwDcAeDOi@{@gC[cAg@}AY{@M_@Ri@l@y@n@}@r@cA^g@zAwBPUDAbB_CdAcB@@tBuCfAsBNOVa@HQv@_BAIVo@tAuCZk@NYJWTa@hBkETi@Tk@d@kA`@{@PUp@gAx@aAfEfMf@zATt@lCjIdAzCtBhGTj@hJyK^_@_CkHwCsIiDiKY{@m@iBm@iB{@oCWg@]p@o@jAkAfBm@z@{@bAgAtASVOi@u@~@m@v@_@h@g@|@aA|BqDpI_B|D_@n@iBjDWh@kE`HuBrCIWs@wBg@{Ay@}B[}@a@oAa@kAEKIWQi@?AYk@i@}@s@mA}AoCy@yAc@s@{AeCIQa@q@gAiB{@yA]i@[k@y@uAWc@q@gAWg@qAyBe@u@YyAI]WaAU{@Og@M_@GOAEAEAMMy@CMEUGa@O_AGYCKGMEMO[IQM[O]I[KWGUCGIQGO]}@KUISEOAIu@}ESoAMy@AKAO?k@CaECY?Q@MBO?u@Fq@LqI\\e_@PuV@u@@wCGsFCgGEm@C_@A}@@y@AuFA_AA}@@{@BiAHwB^sHz@ePBkK?CF_AF_ARkBL_BFiBJaB??JgAPgAdAgGFi@F_@Ji@H]FUJW^y@LYy@{Cg@}BaBmHcBcHiA_F_AsD}@{JYeCc@}CU{CGgAC]Gm@Ck@iFa@EASC?EBE@A?C@C@C?ABA@AB?B??A@C?A?A?E@EAE?CAC?AAAAA?ACACCE?EAK?ASCYCa@Ak@?{@?i@@[D[@MBQBKFUL]HQHOFIDE?w@@IHC?G?G@E@I@EDUPo@FSVq@r@iBh@mAj@yASsA}@FYFm@JO@o@DFoDDgCDgB?cAPMBCJKFEBAr@k@DEDCBE@E@EDKHMLO`@k@d@d@h@j@b@n@jDxHp@bBjDvHhAxB`@l@l@x@pDzCpC`DJN\\Hj@JfAQjB{@`@WlA@R?p@YxAg@^WpCc@HCP?^a@I_@WaDMuAGi@Y_COsAIqDEcCbAaEl@wDBk@AoAIyAIoAMmAQ_ASgAWcAOy@]_CGmA]wQOqAe@iC[}BCu@?g@JaAtBiNPq@Tg@xD}Ev@eAjNeQNGzA]hBc@`FaAVUVc@\\k@i@gA{AyCy@iBcAoAkGgGcB{EQi@uD{KsB{F]s@yB}D]k@}@_B{@}AaGuLWg@e@kA_@{@Wm@Sq@cAkDk@kBU{@oCqHc@eAYu@e@cAg@y@]e@[c@s@s@WYKMMOa@g@oCsIQUW]iD{CqFaFiAeA{AeBs@w@WMg@Ey@g@]SdB_ElF}LtAqDnGuP`EsLdAaDv@kCv@eChAuDn@yBV{@^oAn@cCPu@h@iBn@uBl@yBXeA\\{@`@eAPi@Zy@Z}@\\cAJUJUVm@NWVg@Zo@Xi@b@{@Zi@\\m@`@s@`@m@l@}@\\k@v@gA^g@V[PULMTYV[TYvA{Ap@q@h@g@n@k@f@c@VUd@_@RQb@]l@e@`@]~@u@^[v@s@p@q@pAy@p@g@lE{EfCqClAcAb@ULH`@^j@nAz@xBt@zBjBxGTv@^x@f@tBNv@XrAv@dDrA`Gp@vC`Mti@z@`EEnAPd@DP\\d@\\[^_@aCqKc@kBU]UgAYkAYkAKi@Kg@aCeKiCuLSy@Kc@{AiHy@mDkAiFw@qDFAFAF@JEJEDBJJF?JGLILEVAN?NANED?DDDBF?ZEFAVBF?JNFDJDFFLJHHBD@F@HAJCFGDCBAD@DJJ@D?FADIb@?D?F@BBBF@D@HGBAF?D?DCFEBA@BFPBFB@ZHD?FAB?@D@DB\\?BBBD@DBDFFHDHBJBFDDHFPFH@B?DEBGDQBCBAH?F?@BFP@DBFDDHBLDDBBH@H?HId@@D@@NNB?D?FAHABABB@HAHCRAF?J@H@FB@H@HBDBLHHDF@DBDDDJBJ@N@R?FAFCDOLCD?DBHFJDDF@H@FAHGDGDAD@@B?JAFEJCHAD@J@XHHJBN@DAHGFGFCB?DDFHBF?FELAF@FDLFFB?BADIHULk@BA@A@B@BDRDJFJFUAMDQ?_@@KBYCk@fAoAESEy@Cq@EkAPSJMBG@I?IAEDEFPBBD@BALMl@u@b@g@DG@CBE@IFKPd@DL@A@DDFB?B?BAb@m@DGDKF[Tw@XsA@A?E@E?E?G?ECMAIWmACOAGAGAG?EAG@E?G@G?EBK@IBIDa@Je@FUtBxBr@t@b@VNNh@d@JJvSnPj@^v@Jx@FhAh@jHdCpAf@vAb@r@LdAPb@Ab@EAa@CcAEeAAoAAoABwAF{DDy@N}CH_CFo@NcAJc@t@oFj@_GJaBDkBHyB@eAEcD@kC?qAC[M{BEk@@oBGgAC_@MiAQw@WeB_@_DxAc@nAi@fBw@zA_ApAs@tAeAlBuAnBaBxB_C|@eA`BgB~HiL~@sAz@qAp@aAbAiAdAuA~@eAzAcBrBmBjC}BlA_AjAgAfAq@pAy@xA}@lB{@dBm@zO{Gb@Q\\IVCT@L@NBN@NLBL@TDrADzABbC@VGdCIpBEfCYbEKzAI|@KdAQlAQjAO|@UnAUpASz@m@~Be@xAk@bBi@~Ay@bCy@`C}@lCWt@Yx@w@|Cs@fCYhA]|A_@lB_@dBQrA[fBS|A[hCOdAEd@KbAc@`FQdDKrBMzEM~DQhGSlIIpCC`A_ARYVa@b@Yh@K`@EZCTErANnBD|@ZMTjBNZLFL?NEFK`@@\\{M@y@\\I\\?^Ov@[d@]I_AqAeGW_BEWDo@Z}MHyCP}DFaAHuALkATgCH_A^mCNuAL{@PyAV}A\\eBTeA^kBVgA^yAh@sBv@sCf@}AvD_L|D}Lf@aBZyAPy@^uBJk@P{@PgAJ_AlAgIZqDbAmLJaAR}AXwBJc@\\s@\\m@VWtB}ArA_A~EgDl@]n@]|@_@hAe@rAe@pEaB`EsAtDsA\\MxA[zCs@p@MdAOjAI|@G|@Eh@Cz@Ad@?n@@t@AlBBh@BbAHb@Dh@Fd@B`BVvCf@b@Hn@Td@N`@Nf@Ln@Xh@Pz@^d@Td@Th@Zf@Tb@Vr@`@`@Z~@l@ZRx@f@z@r@`BnAhBtAl@f@lDfCvCnB`Bx@bAj@hAf@ZJVNZN^N\\NdA^x@Z^L^N`@H^L^Ld@L~A^^Jx@J\\HZFv@Jv@L\\Dx@J^DbAH`@F^DrD\\b@DbD^|@FdJhAx@PlATpAZt@PnA^hDv@tBd@rAZpLpDKpAIxAA`BFfDF`ADvAPrAV~AHz@DdB?dAKnA]|CEz@@pBHx@JnFDlANjAl@jE`@bD\\nCJt@d@~GDjAFv@x@bKz@tJF~@NI|@Pr@H\\@bBBHNjB~_@@^zAnTPfAXr@NVd@p@NRp@p@HrB@pBBfALd@Td@bDtDlB|BrAhBbAnBfAlDz@nBVp@h@nAR`@`ChC`@hAItO_@vJ?xDGhBIdGCfHA~IAb@OzAQx@EdA?j@@|@h@|Nb@xH@t@@x@hA@tAEpBCfCQbBM~AIt@UjAQ`@A`DLtDf@h@Xp@v@Rv@d@zBRXZ`@|ATnAb@~@n@x@bATd@tChGb@l@^h@~@`@hDdAt@JXKd@S~C}Br@c@bAc@zA{@REFbA`@g@p@m@hAcA~@q@`Am@v@g@jRoHfAc@l@WhEyBlAs@^O|Ba@bAUzAYpBYnA[ZC~@UVOXMt@i@j@o@^k@Ve@j@u@LKH?FBDR?rH@nDApB?hC?jBCtCKtAEj@E|@CrBM~AKbBOrBIdAIdASzAK~@OfAUdBU|Ak@tDWlA_@nB]rBu@fDe@jBm@`Cg@jBWv@a@tAO`@M^ILIVo@dBUd@Wr@KZOl@_Sre@cCxFaAxBuAhDy@nBmBnFm@rBSp@Ut@M^]jBE\\?NKn@Mv@QrA[bEYvEUxFQdFQtEQXE`@UfDs@vGeCpPg@n@K@K?KHGj@?HAp@JPb@LXL~@|@P\\Zn@`@OBEV_@?e@SmADs@j@mEb@kD^_ENaBVuEAYKe@TeDBw@BcAB{ADsB@m@BaA@@HaCDy@BSJgAA?Hm@J{B?W?E@_@@?HgAFiAJ}@LsAPiAToAR_Ab@oB\\oAXaA^kAlAuDVi@pA_Dd@eAh@qAlAqCnIiSh@sAhAiCh@qAhAmCx@mB^{@j@yA~@iCf@sAb@qAd@sAb@uAx@wCf@kBd@gB\\uAp@aDNu@ZyA|@}E^aCXuBLqAXoBVsBP{AVuCRyBHcAt@mKB_BDcAJiDBuAVgGZuCPqAVyARiADHNz@XhAVhADHTTCPBJb@x@l@lA|@pBf@vA??Nb@ZbAPfAPtALn@BJ?@m@r@[l@]`@C@K@JV??BZFjA@bA@~@GhAA\\@ZDd@HjAf@`ENvAFDPB@BBJBLN|BPzALb@Tp@H\\H`@DPNh@N^BFDRHpCLdAQj@OV?F@NBNFP?@D`@HVDJVf@f@bAJN?JDVj@\\v@\\j@^|@^@VANAZ?XfB`@NFF@D?FCHC\\CLDNDH?PA`B@D@NDTHj@v@DFFDLFTBLBJHRXn@J`BDx@FXDj@J@@DF@HHn@DP@Jj@@XHNHJXNj@PtAh@NzABtGFnDFzGF@uCB{ALqEVkEDm@JgAjA_KHi@RoAJo@Lo@Pq@`BmFVgAbB_GxCoJdCyHlEvH~C~FtAjCA`Bk@xDMfABb@BVBTTdANx@\\pAHP`@^HDTFnAh@D@F?NE\\EP@VCZ?FEBCBGBSx@UZMREn@IH?L@LD|@\\ZNLJRRZ`@BFPh@JfATfCVrBp@xDPnAHj@H\\Lh@JXJTFFPRpApBFDH@v@Lv@ITInBc@f@MVOJALBjAhAv@pAvAlB`@x@f@dBHPh@dAPT^`@l@^LFFBF@HANALCJIHGdBiBlAiAX]Va@hAiDXc@JMHIHGPGjAQlAIlAV`CbA`Bv@|@d@x@Zf@LZBtA?\\CN?HATEhCQfAAjBMzBCd@z@Pf@Nj@LzADXxA|GRn@bA~ADJDFLJRXJPj@hB^t@t@nADJFXVtBJXJRHJnB~BRVp@z@`@`@TLDBr@h@TTB?JORUPKPK\\OV@f@NpBv@hBn@ATEfEAJAPARK|AB\\BVJZHXDZ@ZBx@HdA@h@?n@?j@Ef@C`@Cd@Ir@Iv@Er@_@rCQZIv@?TRb@BH^JHEHCJCJa@Li@GWCOEQ@WNoALgALwAAqAAoA@M?w@?o@Cy@CaAAa@Ac@C_@Eu@Ca@Eq@AWC}@Ae@Aq@@]?a@@e@?a@Be@DaADaAFiALE@B@@??B?BCPGB?FAHAF?DAFBFDHDJHLPDDJHFFDDJNHLBBFFFFFDD@B?DADADGBC@ADABAF?J?H?D@D?DAB?DAHCFAB?B?@@BB@D?B?BAHAD@D@F@JBHDJBHBD@@@@B@FBPDF@@@@@BD@FBJDXBJ?D?BADADa@r@IN?B?F@D@DBBD@B?L?B?@?@@@@@B?F@L?p@@H?D?B@B@BJHFHFHFJDDHHB@B@BAB?BABCBGBKDS@A??@A@?@@@@BLFP@D@BBD?B@J@J?P@H@D@D@B@BB@@?@@B?B?@ABADCJKBC@ABC@?BB@D@P@L@LAL?N?B@B?B@?B@@AF?DAF?D?F@LD@@?D?BADMXKTCHCD?@?B?@?B@B@B@D@B@BBBBBD@B@F@@@FBBB@DBB@D@F@DBJBV@L?D@B@B@@@@B?B?D?DCDEDE@?@A@@@@@B@F?H?P@D@F@FFX?D@F?F?F?\\?D@D@DHNJPBF@FDN@J?D?DAB?BCBA@EBGFCBAB?@?@?B@@@BBBFFRL@B@B?B?DAJAJ?F?D?F@FDR@D?D?DABCLALAH@H@HDT@F?HAHCZ?^AFAFCBEBCBE@C?CAEAGGKKMMGIEEAA??A?A???A@ABIVEHCFCFAF?B?B?D@B@@@BBBDBBBJFBBB@B?H?@?B@B@@B@B@@@B?B@B?D?B?FADCFEHCFEHA@?BAB?D@B?D@B@B@@@@@?B@B?FAF?HABAB@@B@F?H?D?BENEP?D?B?BDL@DBD@DBBDDFDBBBFFL@F@DABADCBCBCBC@KDE@E@C@CDADAD?J?N?F?J@H@B@BB?B?F?F?DA@@@@B@?B@D?H?d@?NAX?DNTJ@F@JJHLDNBFT^LLv@p@V\\@B@x@b@Ff@P~@Tj@HlBj@z@Th@PMpAId@KfA?`@MrAIx@En@i@zFI~@sAfNIx@UlC[xDKpAEd@GRIJGh@@l@l@FAENItBpAzBb@h@TRLnCrAjCdATBtAEf@Bd@@pALp@BVAXEVSLQFU`@u@LIJM\\BH?\\LZ@\\Hz@Bd@LLp@Nn@Lj@Ph@Xf@YXa@^CBABBFDP@D@D@B?B?F?F]^JXVv@Zp@DFh@`AFLn@rALVVf@v@~A\\p@?@BR@B?@?B?BAB?DA@{@nCe@`BYt@Sd@@@Y`AMZKXYf@A@ADAFCDADAF?FAD?F?D@HBFHJhAzAvAzATTHHLLb@l@Vj@B?XPHJLJb@Zg@v@MVe@x@e@v@_@x@MX[v@O\\O`@Wr@]jAa@vAo@pCg@xBeApF_Gd^UtA[zAi@~AMd@]hA[t@gBnEWt@m@tAGKQKo@e@a@Oa@Q_@ESC[K[[GKIQe@J[JCNCD@~ATLLXZbA|@|ANf@f@DN?RANCNMV^GZOb@IXQn@Mb@VT@TBXHb@J\\LZPN\\Z`@\\^ZFJn@Zd@LR?r@D`@HTHh@WXw@BMAs@GOQc@MOI@OMM]GUO{@WkAa@kAYu@[u@Yg@[e@MMXs@hAgCtAwD\\eAPm@X{@d@aBb@mBNs@tAkIf@}ClC}Op@qDn@iCH[@IBIFQJa@FYHW^sAj@iBf@{AVm@Zu@Re@\\q@b@}@V]Zi@f@Jr@^t@h@vA|@p@`@^P`@Tj@VFDLLHLTPLJNHVJj@T\\Nf@V`@LX?V@H?F@FBHHFJR\\DFXT\\V\\VB@`@\\j@f@hAbAB@HFv@h@ND|@`@l@^HBYj@a@\\q@p@[X_@f@MR[d@e@z@]v@Yh@Qj@Qj@Sp@[lAMv@WtBG~@Cr@A~@?x@?hAHjANvAL~@F^Hb@Pt@bB`FH\\@ZCf@E^ERqApE]`AqF~IaAbBwAlCM\\ALC`APFFBLPl@bAzCpE|@lA`@n@T^`@l@Vf@r@nBn@jBLh@Rf@Tn@Vd@L^PNPBLC\\_@HKJu@c@_AOEQH_@FOCIIIOy@kCSk@Oc@Si@Oc@]k@g@{@_@g@_E_GuAyBIQE[FWjBsDnAqBnBcDf@s@f@_AN[Tq@\\oARo@Pk@Tw@Fi@Dq@Cy@Ii@Ss@Yo@]eASs@Sk@G_@Mk@Ei@Ii@Gc@Gy@Ce@AgA?e@@eA?[Di@@SJw@D[D_@F_@RaAHUJe@Ru@Xy@JQHUP[P_@Te@f@y@^g@h@m@r@q@HGLTLJjEx@v@JRBJ@NIlBSnA]R@VCl@Np@Tf@\\b@RKr@hBlAbAf@d@aE~@n@`BhAp@d@x@l@KvAp@VQv@QnACRA`@ALU~@]|AIh@Ip@M|@Kv@CXCREb@GL?FJHNRLVLVFPFTFPFLBH@FAFEDY@K@KAMAEAA?ODMNSZONKJQNORQTFRBJBLDX@PADIJQ`@Qb@M`@Kd@If@Gf@Cf@Iz@Gz@QvAMv@tAh@fAZXFr@FH@t@CXBZFVLXPvApAn@|@hAtAv@x@rFn@bC`@b@DZ@|@?r@CfBWf@KVANAl@Bb@Ff@Lv@PzBb@bAXv@^pBjCV\\bAhBLRb@j@Zy@Pg@RaALk@J[Rc@^{@Rc@Na@B?NUJYRc@Pa@P]T]V_@h@w@Xc@`Ax@nAr@BBHpBJfAKdC?`@?d@?d@B`@H~ABn@d@ClCKbEBp@In@C`@LRF`@J\\JLFHHJLFFNFPBD@DBFH@LBT@b@BLDLJJFFJFRFNFFBv@Nv@L^FPDNFPPRXd@l@zAcA|@o@Bg@FF\\\\HJlAnAPNtAtA?HNHNNTXBB`@VRJf@TLFNNPNJDHFRJHBLDHFMl@Id@SnAETCPId@Kp@Mr@O|@I\\IVEPIZGVGZ[rAUfAMl@IVg@lBCHIVUz@Sx@k@vBk@xBOj@]rA]lAYhAUp@YdAq@bC]jAa@vAQp@Od@GRWz@Wx@IZYz@Yv@Un@Yz@]|@M`@O^]fAW~@Id@e@lBIf@Ib@Ip@UzAOlAM`AMbAE^M~ACd@C^Gb@WlECd@Ab@IjAIzACl@CtAUp@Ez@ARJ`@Xf@NH\\?ZUJUFEDgBM_@MUGOCQCQA]?]CkCJcCDaA@YHy@Ba@HaAT_CLyAHy@D_@x@oFBK@Kd@yBBIFYFUj@oBPe@Pk@Ri@X}@To@Z_Ah@_BNc@@G`@uAd@yAr@g@v@g@~As@RURYL]Ty@PiATaBLeANu@\\{AfDT?xQGnWApEE`CCxBEtAOjCMbBk@hGgCdTcEh]_@|Ci@lCi@tEgAnJE\\KPMJMBS?OC[^ED_@B@j@AvHKVGTELIZAX?XDZJ^HTBJ@T?DX@JHVHhEa_@RBgB|OQvASfBQzAg@lEVLFKFOf@a@\\g@H[?s@?UIkA?]AeB@O@MjAeKp@eGDs@D_ARkCRiBxCuWrA_LFq@HsAd@_DZ_DPsALyAPeBLqAL{@LsBJsCFyAB{@@aAByA@gAJmo@hA@VB`AYn@c@Xi@TQ|@k@vAk@RI\\SX_@Va@Vi@z@yB`BmERk@l@aANQ`@SRO\\]^k@Xo@Vc@d@yBPq@XaAVq@Xy@V{@X{@\\o@hAiBzBmDjAk@JBDzAD^DRFRJPJNv@x@NP`@t@x@jB^|@Xt@jAhD^hAj@tAJPHLNHv@?PFbDfCdAn@pB~@HHx@LXFTHFFFLJRD^b@j@h@\\JBVFh@T~Ah@\\H\\?^Gt@e@z@Yl@@fB@CpG^bDT~B@j@Jr@Pp@j@`A`@NXPRb@f@vBH`@DX@d@Ct@Jn@vAtAHLp@jA~@bBxBhEt@j@p@\\`Gz@j@Fn@AhCJl@Tp@b@ZZl@n@|@pAF^Mf@CNUrBQ`A\\^RAPJ`@L\\JZFtABbABhDXXRLNHXTbARv@Pl@Th@Xd@p@z@RTDFRNRPXN`@RzALLHT`@HTPfADXVd@z@n@|BtAb@PH_ADSl@uDLWVs@p@sBN]hAyAhAwCP]Hc@JmAHgBDi@Jm@VkAZqA`AmDRu@X}@TcATyARgARw@`@oAXs@^u@`CwDJMZO~@Yv@_@bCe@zA[LBNDRL^Xv@Zd@i@VStD_L^gANg@POVSPG^KXC\\E`@@PDV@V?VCNIPMXY`@g@d@m@b@i@nEwIr@aB^sADWZ}@NSTKb@a@dAaA^k@`CaDt@_Ap@}A|@sB~ApA~BnBhD|CzCvCrBpB@@`@`@d@i@^YJFJFJHB@HHJJJJJHJJBBJHLHLFJHLFHDJDLDJDLBJDJ@JBH@J@H@J?H?J?B?FA??@?@A??@?@A@A@A@?@A@A@C@A@A?C@A@C@A@C@E@A@C?A@AJUJUDKDKBKBG?C@C?C?A@C?C?C?C?C?C\\BRBLHLFLDLDLDNDLDDBRF@?B?@?@?B???H@D?@?@?B?@ABABA@?@?DAD?B?B?B?B?B?B?B@D@D??@j@PLFDBB?D@F@B@LAb@{DHo@H]j@`@z@\\pAf@nEpAtA^n@p@|BxB?`ABzCKPS^Q`@Qt@Sr@Mf@Kl@Iz@S|AMn@]v@a@|@Yd@g@pAYt@q@xBiAhHe@rEGnAClABvA?XApAB`@@l@?FFh@Hv@Hx@?\\`@HvBc@PGh@g@RWLW`@w@l@uAR[l@gAL]n@eBPw@l@oCVm@Tu@TeAb@mArBsBlA]ROh@c@V[n@y@\\m@LLd@V|BvAVPTD^?b@Bb@DZRTZX^V`@Rf@J`@Nf@Jb@BNRNPD\\Df@A~AKP@\\LLJZRRPd@T|AF`@?HBJHDVBT\\v@FD^f@^NFn@?Zk@jJc@nIGbBAvAA~A@pBHnAFnAH`AFl@LbAL~@JlAPrAJ|@Ff@Jz@Ad@PzAFZRdANt@Pr@Nn@Tx@Nf@JXbAnDLQTl@`@lATp@Lf@Pr@RfAJz@Jv@@PJzAH|ADf@A|@A|BGrBGvAEhAEfAClA?PCrB?fAAp@E`EAhBGf@]jCG|@KzDFTPl@L^HHRRj@@fAFfKbAzFaAPJ?h@V?R?L?vJbG~CxHlPzIxAR@l@nBb@jI}EdL}DvObBJjAAl@GtAE`BBj@@LBl@pC~B~AbCZb@Nb@D\\I`CDr@DNDFLHLt@LvA^rAVCN?f@RzBv@`@PVLd@Zt@p@`@n@NXVb@\\p@t@~A`@l@x@hAtBbDhA|BVd@R\\HNHPT|@j@zA`@bAd@fAZx@N^RdA\\t@J\\b@pAFHFTXtB^~ANf@RbBFTR`AZlAR|@Vp@Jb@FTJn@JlANv@Fb@d@xAvAdAj@b@TRdAbAjAhBl@bAhAnBNd@qBJIAMEQIMAYBONWz@YpAMv@Oz@Ev@AhDRpE?XNhEn@~Gb@lA`@`ClBxLT`BLj@Rn@Rj@RMtBu@x@[`CiAzC{A|DoBnAcAfAeApAqA\\m@n@qAvAyCtBgEdAy@\\?bAWhAa@fBaApC}AvC{AlAw@hEyB`B_AfAiA|@aAf@g@x@q@pDqCdAm@jAo@|BgA`FWPI^_@Xm@fCgEv@hBVn@Vf@\\j@^n@b@r@n@fAhBnC|AzBb@rATr@Rp@T^b@j@t@r@TX\\`@Pt@ZzBFj@PpELjBAdAA|@Bf@JpAF|@Lv@Db@Hp@Fr@Bh@@l@@`@?^@p@DfATdCLnALbAd@rDBhAAf@^hFDVNh@Nl@Rn@`AtB@rC?`@DnAXzBn@jFVtFPdEAJQbBQlB?f@Cn@WdFDdFI~AEpDLbARjBHl@Jb@\\~@TdATpAl@zCPhAb@`@l@nF?`@_AbCiAxCi@fBqA`DQ`@iApAM`@GZ?d@PfCBn@JlAPvBAlAi@`G?hAOtB?PBj@H`@HZNV@@FFJBJDJBJBNDHDPNLNLTNZPb@Nf@Hd@Jj@Hd@BTFZ@Z@XDj@?N?V?^Cj@C?IAKCYIEAYGWGMEGAWIGAUGKAYEOAQC_@CYCGAM?MAYCCAA?C?CAYSA?AAAAA@g@Ee@Ei@CI?_@Cc@EIAG?GAg@Kw@Mc@MGECAGEGAGCOEQCMEOKGC]QUIKCK?WCCAYEEAKECACAAAGGECOMKIAAA?EHM?EEIIGOIESGOv@Q`@Qh@Sr@c@DYTI?Q?UBQ?K@M?s@FyAN_@BMBMBOBWFKDG@CBA?IBOFQJ[LSNYPC@CBOJIFA@A@A?A@C?AA??AAAAEL@?URk@`@w@n@o@d@KJEDC?C@E?EACAEBBHBCHFJRFJRZMTJPKNKNKTMRYh@[j@KXAFELCFITKVCFEHIRCFGFABEFKTKTEFEHS\\SXQVCE?AQTABEFKPKRYf@@?MP[d@GFCFEDEFMNGJGHIJMPKNCDEDILEHMRCFABABCDIHGLDNa@h@KYEHEHGHABGPMXGNCLEN?BKTITGTOXOZQXIRCJOb@Sn@GX?DCLENELMd@S`@Yh@OROZAAMX]v@g@HYx@i@tCMp@_DvOo@`DWfAQZiB[sCy@wEaBcDiAe@QSOKOKUES?SWS_@CIPGVA\\BRLRPHTB^XTPn@VzG~Bf@PhEpAb@Hb@HXDb@EVe@b@oBNy@f@_CLs@n@{CXwATmAd@{B~@wEb@ClArALTf@dBXf@Hh@d@n@rAz@NR`@r@R^Jb@J|@V~A^r@d@tATr@LXT^Xd@VV`@n@xAfBP^tAjBV^Z^~B~Cn@z@hAt@^Rf@VxA`@rCv@vBfANR~AdAPPt@p@t@p@bA`Af@f@fAnA~AvA^\\pA\\RD\\FR?VATAPE\\GHILApAj@PJLLNNPLLFXLD@NBPDL@NBPBJ@LBB?B@@@@?B@@?@@FBJDHBB?B@D?B?D@@?B?B@D@D@HDF@F@D?B@D?@?DSNFTHRDFFFBLDFD^NLDNFVHLFH@NFNHRHZLB@JDD@ZJ?HGxCAr@GbCAZ?d@?d@Ex@A^?R?`@Ah@?d@@Z?R?PBRDz@KFQJKFGDgCr@cAXy@T_AXwA`@o@R]JkBd@g@NYBYFG?k@JC@GBE@ODC@E@E?W@o@XWHsDdAa@Ji@LaB`@iBd@kBd@eAVYL_@P]NSFYHYHi@VEBYDa@Jm@H_AVoAb@u@Pm@@q@AQBa@LSDi@H}@FOBI@M@E@A?AACACAC?E?E@G@C?KFg@Rs@ZQHC@g@EKAG@a@H_@Hm@LG@K@GDINMNwPbEIAC?G?C?G@E@E@E@EBE@E@EBKFKFE@CBE@EDE@C@GBE@G@UHg@Pe@NqA`@C?c@L]@e@Ic@Qs@a@aAs@{@[q@KcAEcAKyCq@e@SSGQJaAc@qA_@qBi@gBc@a@KG?K?I@?ZBt@@t@Bp@BX@VFr@BPB\\BV@XBPBTBHBJJh@BL@JDf@@LD^B`@@Z@TAf@_@@UBa@Fw@XgANcAXmCx@y@b@kAXsATcA?y@FkAP_AJi@RMBuBXY?c@De@De@@[FsAd@aDlAwDdAwAn@{@?SH}A^aAFo@L{@NgAXq@DqFvAkE~AgALs@BGCECmAyBSMOG[Aw@D}@AMCwA}@uAGi@IK~@Sz@_AdCe@v@c@\\g@b@KNi@|@{@dCUf@Qb@Wb@g@n@_@b@c@XYRa@Pc@HuAVa@Jg@FD`APvCF|@JjBH|AJbBRzABNLp@Rz@Pt@\\]bB_Ft@wBZu@Fb@BXLt@v@lEDCv@KVEBFC`@]zD]dG]~DCXAVAXAX?X?VAD?V?X@X?V@X@X@X@V?B@`@B^B^@H@JBL@J?@Xh@LVZY`Ag@b@r@B`E~FpHqFfDw@n@_Ap@q@|AyBpCs@~@iG~GcB~BuGlJqLpR[h@gAxB_AtBa@l@gA~AoAjBaAzAQV]^aDjD}CnDa@h@u@nAkB`DaAdBgClDe@r@kAvBWj@g@bAWp@e@pAi@pAy@jBc@dA_@r@O^W\\UNOPe@^YRa@Za@TkAp@}@b@y@\\uDpAw@^k@XQLyAz@MD[RQ@a@Bi@AQEg@WiAi@EOk@{AMI}@OIHIA[j@DbAJ^FPDRTJf@MLOz@R`@NnAf@j@LVFNDb@N`@i@HOp@c@^[~A{@t@Yb@KbBq@b@OdA]tAu@b@U`@]t@e@p@m@n@o@\\i@f@{@Pe@|@wBXk@t@sBj@wAb@_Ar@uAl@cAf@w@h@s@d@s@|@mA`CcE`AeBZg@Xa@\\c@fAoAn@q@hAoA`BeBj@y@x@gA`A{Al@_ArAkBPa@h@kATi@f@cAj@aAzBuD~@}AdAcBv@oAd@s@BFBN@R?d@BXBNDH@DBDUZAJMXGVMd@GXCNAHAb@?P?L?NMdBAN@L@R@PARETAXA^APEXI`@ITQd@FTHl@?J?TA\\AZ?T?P?L@FFf@F\\BRB\\DZHt@Hh@BPFXJv@JhABJLb@H^BLNb@F^D^DZN`BHv@Hj@ThADv@?ZCn@?V@X?TA^?R@L?v@FxAAPAJGh@Gh@AXCXQZQRIN_@z@Yv@?NEr@Gh@Kp@YrA?HAHCp@[vBIb@Ed@K~@Cn@AX@RAVT`@l@tAv@nAn@`Al@l@VTz@n@\\P|@^l@b@p@`@jAv@b@Nn@P`@Jd@Rd@NLDHFNJJJHHRNVTJFf@\\f@^`@zDChAGtEDzBH|AFvARnC^dAn@bBXhAPv@ThAF|@B`ADrAF`By@dAML]Ri@PuAh@uAj@iA^u@Ra@P]Na@X]\\i@j@a@b@a@d@STSTUXWd@_BrC_BdD[j@_EdIYj@oAbCWh@]n@Yh@s@tAWh@Yf@Wj@w@tAi@dA}@`A_@`@mD~D_@^mBxB_@`@}AnB_@`@\\f@LHNPNHNJPTNTRh@Vn@xAvDXv@JRLb@PRjAfCxAhDh@tAfAtC^`AFZFZH\\Hz@PlBNlANtALfALx@PfAPx@Pn@Vz@d@nAXn@R\\f@v@bBzBfA`B|@jAd@n@l@lAJZFXXp@jBbEHl@BRA^Jh@N`@d@NPY\\?Dg@Be@PUXAF?t@Kr@Op@Wb@Ox@[pCeAnAm@tAq@dAg@n@]`A_@d@OzB_A`@[POdB}Ab@YTMp@_@PKXMb@UZSb@Wj@c@fAwAVa@Na@Zu@n@cBv@sBt@aBf@kAn@kAh@s@V[xAiAxAfFJ^Tj@PZT\\ZZ`@Rn@HxBXpAJVBp@KlImEd@bATj@RbANz@@ZVhAL~@Rf@Hf@HdAPjADZH\\@F@NBb@?DBHBJFLF\\BNJnABp@DjAJPRxB@TNzDLpC@|A\\AlFKbAB@D?P@PBf@@Z?P@FBT@FBLBPJ`@DRFLBFNZDFLNFLBDn@z@T`@N?PHPLJDFDFH@DDHBL?TCXINA@_@`@Pr@?@T~@HfAPzAHt@IBYTCBe@TQLQNWZi@r@Wf@Ub@a@j@c@x@g@~@S^QZU\\a@r@Yf@Q\\Yd@S\\Ub@gB|C]l@{CrFqA~B[h@uAbCWl@]p@a@bAy@dBSp@Yp@c@x@gAdDy@|B]bA{@zCgDrKsBbH{@vC_@|Ag@pBUdA[vAe@fBi@xBe@fB}@vCm@hBa@rA_@bA_@p@Yd@[h@]b@]j@c@j@u@bAi@p@a@d@sA~Ai@h@wBxBoMjKoHtFY`@_CjB_@TIJMLWROJML_@`@u@bAqDjGQJQLUXMNi@bA}AxCQHAbAAp@Uf@`@j@h@h@Xc@LQ`@C@W?]BQBYFe@P]VYTq@He@Dk@Aa@@]FWfD{FXe@`@o@t@y@~@cA`@KR?Z?ZSNQJMLWLe@HW~CaC`@WfBwA`@YhByAlEmD`CmBtAsAv@y@jAsA|AkBl@y@V_@n@y@f@s@T]JSV_@HOJQHMFKRg@Vm@r@yBh@_B\\eAX_AdAeE`@cBf@uBLs@h@oBRy@TcA^sAX_ATw@b@yAl@gBr@iCr@_CZcA^qAX}@d@_BXw@Ro@Vs@Xw@Z_A`@iAVq@Tk@Vm@Z{@h@iAp@{ATi@^s@\\m@Zo@j@_Ad@{@Ve@`@s@h@}@n@qAXg@Tc@bAgBZm@|AuClAkBp@kAd@{@Tc@Ve@`@o@\\i@b@w@Xe@X]RSVSZQ^SZMPzAH\\Zd@h@lA\\|@b@hAh@zAz@rBRr@b@_@nAu@r@i@`Ay@dHyFb@]hI_Gf@e@d@KXt@Vz@T~@lB|GpAbFFLV\\`BrCxBjDJNXXd@h@hASR?\\Db@?`A@h@CbCSTPPJ\\FLDx@x@BBJ`ANNFDRFRDXBBjEZZtA|@TYR_@FAlAPZDr@Fl@CL@rBj@`ApFXzAThAv@fE?jBoBxAOLICIJ_@`CZ`Ar@bEb@YBHFHDFLBPCbAa@`@{@Vi@J[P_@JYH[H]Nu@H_@B]Da@DW?g@?gA^?Fk@rArDL^vBdGRl@Nd@JXVp@Tn@HVrBvFPf@r@lBX|@b@nAN^m@t@g@f@{@bAoEpIU`AEd@?zA@bAB`BHtARlCFzAVnFH~ABtAFrAB~@?z@?rA?jAAjDAdAI~DEjBKpBCp@Q^[n@y@vA_@b@q@fAYd@g@n@SZKLQVa@b@_@^iD|CSg@_@VTl@]T{DxAe@DcCXc@HSFa@L}AXg@?}ELu@RgEv@c@P_Ah@a@VK@QXM`@SdAId@Kj@Kl@Or@Kh@Of@Un@UXH~@u@~Bw@fB]l@aBzCm@~B]pA]vAc@xA_BfFuAbDWp@qDrJO\\IXKZO`@aD~J_@hASn@gA`CYj@Wn@[l@S`@q@n@[TcDv@e@NQLe@Z[LOTyApAe@p@Qh@U|@]dAY`@QZMNYNz@v@|@~@lAjAx@r@~@x@n@j@v@t@DF\\VfAhAp@p@\\^j@p@\\`@\\`@Z`@Zb@f@r@f@r@d@t@X`@b@n@Z^\\`@DDFBB?G\\AFI\\ACEGEIOSW]e@o@[e@Ye@Y_@y@iAg@{@[a@[a@]a@k@o@[_@]_@]]m@k@o@i@}@{@m@i@m@k@_@[]_@k@e@_@c@_@]k@i@_@_@q@u@w@jAWXc@DQ@g@F_@P[Do@DIxA{E~E[Vq@MHhA`@r@RpAXbBPlAZlBVfARp@Hj@BV?`@CdAu@pJCl@E|@?f@B|@@n@Fb@Dn@Fx@Hv@L~@VjBJb@Jx@^jBV`BTpANx@l@lCn@xCTnDDx@v@tJFl@RlBBz@Bz@D~@DbAHnAp@lGZ|APv@oBjBODOGKWi@NiA^aAZ[Js@RMBYJYFYFQD_@}A]_BMk@WgASw@YoAKc@Mg@_@yAOq@Oo@YgAWiAS{@Mk@U}@I_@GUKJSN[T]VUPEF_@\\WPIFUJ_@Z_@V_BnAsArAw@r@Vp@_@b@nAxC`@bAN^Tr@iAzA_BvBKXILKFA@MNeAvAe@p@iBdC_C`De@yBID{@\\o@Vi@Rw@Xe@POFm@RWDO?MAIEOaAm@AI?GAEEEECGGKEOEOAGCOCMKwAC[AYCo@Ak@sG|C|@pNPpCt@dMDf@H|C@L@b@aAG{@I]SkAk@kAq@k@Sw@U[KYCo@Kc@I}@W}BaAoGsDa@Ma@^DX?Z?dTDbDH~@Hv@H\\L\\Ld@Vn@Zt@~@zBPj@Rv@Db@S\\_ApBe@~@Sb@S`@q@fBm@nAq@|Au@zAc@`Am@rAMXQ`@O\\ITMTS^ILABCDk@|@Yf@S\\k@hAa@r@Yh@U`@[p@c@|@Sd@Uj@g@nA]|@{@zBaBpDYn@g@hAcA|BaBnDk@tAGJGTa@tAe@rBQ|@y@|Co@dCq@lCWlAq@vDuAvIAf@]DG?Yx@wAhIs@hFWhBIz@n@h@h@b@`R|NvAhALVFTQ\\SLWLcC`AcA^sB|@E@SJkBv@EBKDIBy@^C@UH_A`@_@NoB`AKCsCfA[^u@Xe@PoKnEg@T_@N{DbBkB`AiDjBuAz@{@j@sA|@s@f@uAbAmHtFaAt@QLmCrBWNa@Xy@\\gH|BuA`@{Ab@KDg@Le@P]Jq@`@cB`A\\nBXnB\\jBJZZl@T`@DNJXNb@FPLr@A@Jt@JnAL~A?b@?ZAf@At@@x@B|@?v@@`@BtABdALnBb@dGN~BDh@L|@B\\@Ti@NiAb@OFKDQB]H{@d@k@^}@f@_An@a@b@ALSPUPy@f@y@l@qBbBgDnCUZMJUJMD{@n@m@j@KNs@~AKV_@x@k@`Bs@pBi@dBa@fAOf@k@bAk@`A{AnCc@x@c@z@Wh@c@z@m@hAKXSn@q@s@SY_@[yF_GSSEGOQMMGG[]q@u@m@s@gD{DqAuAw@}@y@aAO[g@u@e@m@k@x@oAfCUd@i@hAKVg@lASd@_@~@}@|CWr@wB|Ei@pAgCvD]d@cGpI_@f@w@hAeA~AWf@]TQXEN?\\?\\FZLV@L?NCZ?BAFCLEJEHEFa@r@MTSXKT[v@EHMZQh@]z@gAjCUn@Sn@M^MZS\\Wp@Un@Wn@@@Wn@Wp@[|@Yv@W^IJQL]Te@Vc@RUZsCpHYp@kEbJGPk@rBKVMTkD~Ek@~@}BrD]h@a@t@k@bA]d@y@pACXo@bAQXc@v@u@lAW^GJUNQDg@UOMw@k@y@i@WOQQSOIEGCMIIGECMEKEGAMCg@AW?e@FYD_@Fo@@WBWAm@Es@IgAOe@AwAM}@Kc@Ei@@u@?gAPs@NgANqAHcBVc@RQJKBSBIAYYEQ[?SHOFWn@@TEXGZN|BVPRVNn@f@nFh@fFb@nCHf@RjAXn@Zt@Nt@ZhA`E`L?THl@dCdH^tBZj@n@~@hA|CVp@nCtHz@`C\\`AhAvCVr@n@dB`@nAxAxD^`ATGJHR`@JRj@fAHP^n@v@pAp@|@V\\X^^b@b@d@f@h@ZZ`@`@r@p@p@p@vAxAd@d@r@p@JTDJbDdDLPn@fAb@b@pBpBj@l@tIpInApAXb@Nf@C\\B\\VXFJ\\VXA\\Ev@H`@p@vFrFpArA`@h@r@p@r@n@r@v@TZTXR\\f@t@d@~@Vj@j@rAp@fB`@jATx@XbAh@fCPfAVdBHp@XnBH`AFz@DnAJtBDtA@xAA|C?hACr@A`AG`AEr@Gt@KfAIdAiA`Ku@lHUzBw@hFiBxPIF}Ai@eA_@[Kk@QuA_@aBc@e@QiBk@a@OUGa@OaA[a@IyBu@c@QsAa@w@Wu@UkA_@eGoBuAa@a@GuASWCw@Gg@Ei@Bs@Ds@Bs@D{FhAi@Ra@MQt@Y^W`@]p@]t@Yl@o@pAo@nAa@t@Yl@]j@e@|@Yn@Uj@Sr@St@Wv@i@nBM^Ud@SXUf@kAnBYh@w@tBOl@_@|@u@zBYn@Sj@_@fAQb@_@dAOd@Ob@Wn@a@|AW`Ag@zAg@fA]t@o@xAWf@WXeAv@gAn@[f@x@~AbAtBh@dAr@fBn@lBc@n@QV_@b@}@rAdApBZp@Zr@Xt@X~@d@|AHh@JnAJv@Hd@Px@LlAP|AJn@fAtGf@pDDr@FbDCz@SrCMfASvAENCNM\\OZWp@O^e@|@uAdByB|CY\\[X}AhBML{@p@kDxByAjA]`@[f@aFrHgCbEcBlCQT]^sAlBcApAW\\YX}AbBk@f@u@h@w@l@c@Xk@X_BbAg@l@mApA_@f@e@n@Yf@i@v@MXWj@IZQh@Kf@WbBGl@Gl@m@c@o@a@Q]g@YkAy@OGa@MIIIK]ZO`@FZGn@GNENqAfCo@hAgBjD{A~Cg@nAi@lAeAfCc@vAWhA]rA]fAYr@u@|Ag@nA}@rB{@tB_@fAw@tBg@vAk@vAe@tAW~@WfA]pB[`B_@hBqDdPUz@ShAU~Bg@tECfA@lAAl@SfDKt@Qv@Kb@On@EbAEj@Ir@En@@f@At@@~@Ht@FlAJt@N`@BvBK`Cm@~Lu@zJ_@dFEx@E|AC~@MlCEn@EbACnA?`AB~@FlADx@XpCPhCH~B@r@BhAEjAIhAEhAMhBIlAKjBMpEKjBQrCI~@c@`DGn@EZC\\AP?b@?`AAh@SBQJmAn@E?_@W]Aa@?_@F]@y@FeAL?KIEi@H[J_BPa@Hm@N[D??oAXQJs@PYLWROJ_A|@Q[cAiB}@eAEGgHbRoBjFQd@Od@GPABOf@Mf@Of@Mh@Mh@Kd@?BMh@Kj@Kh@?FMn@Ip@Kp@In@Ip@Gr@CRGp@Ep@Er@Ep@Er@Cr@Cp@Ar@Aj@C~@AbAA|@?B?~@?bA@`A@~@@h@B|@Bz@D|@Dz@Fz@Dz@Hz@Fp@Hv@Ht@Jr@Lt@Jr@Lr@Lt@Jr@Hb@XtBVxAQl@CPMb@c@pASn@ELGPc@hAe@nAOTEGWYSYUWc@e@c@Yo@a@iAw@aAo@aAq@cAo@_C}AmCcBe@]c@c@k@e@{@w@o@_@o@c@w@i@g@_@[]c@c@W[s@eA_@g@?[Ee@U][i@YVIDKFEDJXFPHPFPHPFNR^R\\NVRZNRNRTXRTPPPNNNLJVPRL\\Tb@XXRHDTN?h@OIGGo@a@UO]USOYSOKSSSOQQ[_@SSQYKKIOOUOWQ]MYOYKYMYISOY?|@?z@FRCh@K`AK`AQ~BAd@E|CBfBCx@Gj@Gz@Or@WhAa@zAQh@a@hBOz@WlBGhAUhCYbCk@hE[jCk@pEMn@On@g@jBg@|BGd@In@Eh@Cl@Cf@?p@?j@@`@Bv@Fn@JtAHZAdAh@?t@b@rA`Aa@|@?T?JBd@HrAFbAThBF|BXnARx@Lp@BHRb@h@`A\\|@`@rA\\rBDlAFrALvABl@D|@@h@Cf@Ct@?NAdA@fAa@K[IWAc@Ao@?e@?SA_@C_@I_@Ma@Sm@[s@e@c@W[O_@KQC_AIwAIc@GaBUe@GsC[c@KcCi@YOs@c@u@EB|ABr@RxBFz@Bx@L`DNjDrCvMpA|B`CbTJx@\\rCJz@rApLJx@J`AJt@_@PGnCA^AX??AjAIzEEjBI|DAx@?FAb@Cj@Ad@Ah@?^?H?FC|@G`EAbBGfCmB]gAS@EoAUkAS{AYyBa@OC}AWmEu@aCc@r@lF^zCF\\\\bCRxAP|Af@|DXdCP|AN|APfBJpAFr@Ft@o@Yc@U{@WgAa@]ImA]w@Ug@Ka@Qo@Wu@c@y@q@wAwAqCuBeB}@kFgCq@a@_B{AYSwAy@g@UYYu@i@oAcAa@a@kA}@aAiAiCqDGUs@s@_@o@GGm@]c@DQZEDWXUjA?LPnATZPNNJXHR@LTJPBNF`@BV`@rCv@pH`A~IJ`ANnARzANlAx@xG|@jHPtAJx@@NYDc@F_@BU@q@C_@CyAMsBMe@DQv@CZAb@HvCLxFJfDDbBwDGaCCkEGwBEm@Ad@mHgAm@SUEe@mBa@YE{AKsBIi@Ey@Ey@?e@?y@A[?a@C_@Kd@iARk@n@gBX}@XcATmAL{@NgAN{@D[LcALoAAKBYU}@c@SMDq@JIf@E~@Ht@VPXTFPBTKn@M`A]tBc@fBKb@Wt@[z@Sh@c@hAgArCm@jBYdAO`AShAG~@EXCXAXIrDG~BQzBMbDOxBc@pEIfAEh@An@Ax@?^?xAAtCAf@StCk@|Ho@xGGp@YhCETO^M\\eAhBoD`G{AjB[wA_@^STYf@Q^Qf@In@ERCRMnACpA?V@hDAxC?bCAzDBpCL^DvHA|EA|AAx@Ap@GrACb@Cf@IfAWnBWzBUdB?@?@A@AL?@@PBL@JD\\?ZCb@EXI\\KV[RUR[\\CDM^ETEXu@lDYnAe@jAOvB_@c@OKECMCi@D[RKP]BSDe@O}B}@mDiA_B]{@M{Go@aBQs@Is@?W?i@Ay@Dw@Fk@Hk@NiAh@s@`@w@j@mAlA{@dAgAvAoAhBmC`DkA~@cBz@Ke@@m@LgA?IIw@GQO]UMm@G]PMTQh@Mr@B\\Nv@f@r@TFNFHZ[H{ANuA?]GYC_@Ii@M]MiMwE[y@I]cAJGRMXE\\QLK@m@Y_DwAUM_IoDgAi@gAw@[c@Wh@Y@aA@DhBApCCdBEjBBpAGhBGpBCv@ApA?fBBbC@bC@rA@`ABvBmBoBcEeEqBuBaC_CaBuA}AiAmDyBcCqAgDsCgAg@YI_B}@QK}@{@a@c@a@e@m@o@i@s@e@q@eAiBi@eAyAwDSm@y@oCSmAa@aDIaBEw@AkACoAB}DB_EAaDCcCCwG_@qBBmDAaECgEGcFEgFCiDC{ACsBKwEQsGKqE]mHOaDCo@IwAqA_Si@aIKyBEsAKcDCkA',
  'mspxHpit@S|@a@`A[j@g@p@g@j@eAjAiG`HaAjAk@p@y@|@ONy@z@aDrD]\\q@r@MRUVo@p@URy@z@[^KJe@v@ITMZARGXLVFNpApAbAnA^d@zAzAn@p@j@n@j@v@l@`Al@bAf@|@x@zAh@bAf@hAh@lAp@jB`@jAf@dB`@bBPv@P`ATtAXrBNlALxAJpAFlAHvADdC@|B?lACjBC`AC|@I~AOjBGx@OpAUxBg@rE_@pDi@~EVAsCpXFf@Gn@@f@ONOJw@lHWlCEbAG`AAt@A`A?tA@fAF`ADx@JbA`@fDRzAHTNzARlBJdBDt@F`CFxCn@fBTl@Zv@h@hAd@t@h@t@TX`@f@p@p@`@ZXTd@X`@Tf@Th@Vr@Pj@Nf@L|AZPSPUb@q@l@iAVk@FOHWHYFWDIDGFEF?D[b@PEd@UdIb@?zBPlFd@|@F`BPvALdBJ|U~AhCXbFfAlBn@dD|AfEdChAp@p@Xt@h@x@`@j@^bBpAl@d@r@n@f@f@d@b@ZVxCnB`AxA`@r@XpARd@^jA`@rA`AzCt@lAb@v@`@x@h@tArErC~CjBzCvAnBdApAt@^`@fBi@zBgAtGwC`EkBhAe@dB{@XiCVmBb@_Ch@sC^oBv@{D`@uBjAuF~A}HT{Ad@qDd@qEF_ATgBPiATaA|@eCn@cB~AoEnCmHTo@ZmAf@aBp@kCXuAXsBVaBT_BJeAHwABgB@u@AsB?uBBmBLyBg@EQHg@Bs@Jo@?y@Ju@?q@SqAq@[O[M{@Y[I{@Qk@I_AIc@Ia@K_@K_@Mo@Ui@Mm@Sg@]SQSUi@u@Y[cCuC_@m@e@gAQ_@g@o@i@i@k@_@k@YmBs@q@Wo@W}Aw@WOYQa@]{AaBo@s@[i@_@}@i@s@c@s@e@cA]s@a@y@mA}Cy@wAy@oA_AiAo@w@U]m@_AUa@Sc@iAkCKMMYQ]Yi@IGEAEAGA[?_@Aa@?u@?M@YEGAE?]QEEIGIMGGKMQYEKEGEE}@eAe@e@_@WUOCAEAC?CCSIQEQCC?WDWBO?MA]EWCOCMAU?OGGAUKUOIE[UMK]e@QU[c@Ya@S[m@YEGGCCCCC?CA?AAa@a@a@YEE[Wi@a@YSKGOIECI]Mk@U}@Om@IYOq@I_@EYEWQs@CKC?EAAAGCEECAGGIIIGEEEESSOMo@q@YY_@]@CIGi@i@GEMSIM][EEGEGAE?A?ABe@vDKt@o@lDSr@[~@U`AKh@IbACb@Ep@Ax@g@fDe@nCI~ABXAh@IlAC^Gn@_@pCSrAM~@i@dDMp@UbBMvAC`AGtAAjBArADnA@l@Bz@NxBFdAHjCH~AJdCLvFBz@HpCFtDHlFDjB?pA?h@?b@?D@B?DFJ@BB@Hb@@TCj@GLS\\O@OAS?MSIm@Cw@JOHQDKBO@U@k@?m@IiDEkDEmDE}@E}AMwEC_AMcEGmBGeAMeCGq@IiBEiBAmCBaBBu@A_ALy@N{@b@sB?y@nBaOH}@Bq@@qA@s@Jm@`@cCN_A`@gCDiABg@VaBIMAKIq@AOAQGYIUKYKUKSIMKMGEKGICGAGAEAKGIIaA}@USm@q@s@aAa@i@KQQ[O_@IUKQMQ[c@QW]i@SUOOGKM[IYEQGWGg@K}@GQWu@KYIQU_@]e@UYg@g@c@g@IOIOIGMGOGQKKGKMMMMWQa@O_@OUQSQ]MSIQGMEMM]GSIYIYe@wBUqAGYC]CkAIs@CSCQM[Sk@Qg@]u@EIIIUSGAIC[?u@CKCMAMGQOYa@Yq@]}@i@uBAG?[Ca@EMWs@CKOC]G_@Oa@Wq@i@a@_@OUKQOc@[{@QWGZOp@',
  'ie|yHqfBDvCPCBvHCtBOxDSdCk@SF{@ZoH@wF?cCAaCRC',
  'a~kyHmbc@`@g@H]TcBfBqLRiBHw@LkAHeAFeADk@Bk@VBGz@GdAGdAE\\`@DMbBMpBOvAg@|Eg@lEM~@ShBAPAPBR]M_A_AUi@BE',
  '}cvyHauw@a@cJUyGOuEM}EQyFKkFSsGOsCCa@\\IfAYfDeApQaE|@NRJn@lALx@H~@@lBo@`VEbBCrAJzCj@IfPeBlBBbAHhEt@`BPjLj@vGj@h@HvLPx@DjALbF~@tMb@b@CJCd@OhDiBlM}GvB}@d@UvHiD`EyBNCDj@H|@zDk@jCe@lAW|@Eh@~LHzBVpDL|EPtDFzBP|DPlBAnHHhCRnCPt@JlCJvADhDJ|BDnBRbEHrC^dEZ|BOj@aAYs@UaAWyAc@mA_@oA_@sCu@sC{@i@OiB_@eB_@uAYaBYcAQoAUeC]y@IyAIqAMy@Kk@GeAM]C_Gq@}AQcB]_@C_@Ma@E[G{Bg@_Bc@_Bi@uAg@y@Yc@S}@]u@_@}@a@aAm@y@c@iAk@SKUQKIYU_@WMG[WUOKM[U]WGGGE]WKEQOQOMOOOUQcAq@][u@i@q@i@QMc@[u@e@e@]u@a@g@Yi@[SKKGa@S]Qe@Sq@[m@Wy@[eA]s@UcAWgAWmAWg@IaAOm@Is@Go@A_AEe@Ag@Ee@A}AAeA?q@@w@Bs@Dm@Dm@Du@Hq@Hu@JcBZk@Lk@Lm@Pi@PGoA',
  'c_uxHtpp@DZD\\Df@Fh@??A@A?A?A?A???AAA?AA??E]Ge@Ee@Ga@Gc@@E@A@C@A@C@A??Lx@',
  '_~txHzvp@Fh@BV@L@LBN@J@J@J@L@J@L@J@J@H@JBVD`@@H@J@H@J@H@J?B?B@DARDH@H@H@H@HBPBTDR@H@FBP@H@F@F?D@HBLBH@F@HBN@HBLBNBLDNDVMJ?AKe@QcACSCGCQAIEUAIAGAIAGAGAIAIAIAKEYAKAKE[?GAEAG?GCUE]AKAKAIGm@AMAMAMAKAMAKAKCUCQAOAQEYC]LG',
  '}_|yHyuF^lBgCeAy@qA_@c@k@i@a@e@}@y@{@aA{@{@aC_CIIS[i@}@gAmBgGyL_A{AS[{@qAe@u@]e@a@c@wAaBgAcAi@c@i@e@]Uq@g@_EqBc@Sq@Up@JlEbB@??@dFhB~@\\nAb@bAb@z@`@~@`@ZNt@h@ZRZ\\tAfBb@v@fDnH\\`ADJ@?BDDFDFBDBFPXNTd@|@^n@\\h@j@z@\\h@hCbEZj@Zb@j@|@`@tAVh@T`A',
  'ix{yHksFRJRHd@P\\JLBbAR`@HZDl@Dn@Df@?d@An@AbAOp@Gp@SqC`B_BbAoCtBsAgAw@k@_@UyAw@sAo@kAg@CSEYO_AKe@IWKa@Ma@Sg@r@|@RPRNXVRN`@Zf@Zp@\\',
  'o}{yHwaF@aAASAu@G}@Gc@Ky@I]Me@Me@Sk@MWUg@~Al@LhBH`BDzABlCE~AGpBg@~@Wl@L_@Ni@Je@Fc@Da@Fg@Ba@Be@',
  'c}{yHmoFB\\Bp@Ff@@d@Bz@Bx@@n@ArBC`ACj@AZJQJK\\a@^a@f@e@^]d@_@d@_@p@k@~@w@@CoBaBg@Wo@]}@c@s@[s@[',
  'qn{yHigF`At@\\RZNTLPDRF|@Lt@Bl@Id@Kt@WzAaAxBuClA}ATUVWNQTUNMVUXQPOPMXKRKNI`Cg@pDOdAE|AIk@CeAC{DKgAGiCLwANo@Lu@NaBj@o@RqCvAy@`@sAp@aBdA}BtAyAfA',
  'q`uyHnrzAKAM@]vCLNHB^kD',
  '{auyHryzA[Y[bCCf@GrBCt@TDLoBLoAFi@LwA',
  'yk|yHwdA@g@J_@LOzAq@NGTCRJLRN^d@fBFd@Al@GLINQX_Bv@a@MW]}@iC?_@',
  'yixyHswGMKg@Qo@HYJOLQNMNQRMXWl@Gb@Ct@Hh@H^FLT\\n@f@TPZATIJQ^aAn@iCNi@?]Qw@Oa@',
  'c{xyH{~p@VyJRBWjJSH',
  '_bdzHx`s@c@t@c@z@Uj@Q\\Qd@NZNUT\\nBcEc@aA',
  'mwgzHpro@@]Io@Wy@QYQSSMSEIAI?OBE@GBC@EUKa@Mo@UgAOw@EK[gACMCMIUG]EUKc@]wA]iAEQEK_@s@M}@CMAKAOGYEQAQCOESAE?KAG?IAKAQ?S?K?I?GAME[AKAGCO_@mBSaAMk@ROPOb@c@S{@K_@Kc@I]CKI]I_@G[GUG]Ki@Ki@G]IYI[EUGQEQIc@Mc@KHeAt@I]GWGWE[AKGUIUO[EM?GAGAGAKCKEKEOK_@I_@CSGs@KuAE[CWA]Am@?[?q@DAFAFCFG`@YZWVK`@SMg@[kBY_BYoASw@Qm@Sy@IYKe@EQEMEIEMEIGIGOAI?QAOCOEMK[M_@GUGYMc@?_@]}@Ik@@AM{@JQAIx@QtAc@lAg@p@e@~@_A`BcBzC}Dx@wAXg@R]TYZc@Zg@jAuAh@k@p@s@b@Wb@SzCsArBmAZSlAeAl@w@JMFIVg@Tu@Hm@?eAAUEc@WuG@QDFRh@PVVb@n@tAf@x@lA|BtBlDPPJPd@v@Lb@DZBX@p@@t@Bz@Dj@Dx@@b@h@hEv@lEd@xBn@|Cj@jBj@vAd@fARx@j@bCfCzIz@~Al@~@Zb@d@lAx@lCz@bCn@pBp@~BTpAh@bBNr@l@`Bd@jAtAtCT\\bAnBrJfRZt@fDzIF^E|SEfDGnCAjACd@OpAUbBIb@St@Sl@Wj@Q`@mAnC}@zBi@jAODQAc@EOAE?cAJI?QW}@s@s@o@wDwCgAw@u@i@{@m@i@]e@YaAe@g@Sa@Qw@[cA]_@Mm@Si@Oc@KYIUGSCk@Iw@Km@Ii@G}@Mq@I_AMaAMyAUkAWAJyBc@qBa@yASuBQo@G@M@oAAE',
  'aa~yHogM]gA]gABCU_ASw@W_A[kABAK[GQQm@CC[m@ISKSCICKGMGISm@]iAU}@YqAe@mBYuAQ}@EUAQ?[?a@@y@@WB[Fq@Fs@Dm@Bi@Dq@Ds@BYJw@Jm@VkAFYHYFa@Gi@t@UZIVKlBi@`Bg@dCu@\\Kj@Qf@MPA\\CR@jAR`@Bd@Bh@HnASf@GhCW\\G|AOf@EbIm@h@?jBDf@F^D~MjACR@DBHBBuNvQ]b@{AtB_@b@yB`D]d@oBtC]f@u@|@a@l@QR[\\}@j@c@\\_@TwBzAa@TcA~@m@r@q@t@a@d@eE|E[`@sCdD',
  'wcbzHadC\\a@zBkBp@_@VKzAk@b@Ir@WNC`E}@tA]r@SpA[bBw@~@_@t@i@~FqG^q@t@mEyDcB_Bi@u@Qs@M_@EeUsEYEgB]k@KS\\g@`BUn@IhAMrAEd@[dAUZu@t@y@t@A?WZEFMPOVw@tAU\\ENc@pATTLHb@ZXN\\VV\\P\\z@`DbCzH',
];
